import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDropzone } from 'react-dropzone';
import emoji from 'react-easy-emoji';
import Lottie from 'react-lottie';
import { Link, useParams } from 'react-router-dom';

import * as animationData from '../../static/other/dynamic-bar-graph.json';
import '../../static/css/Tasks.css';
import announcement_icon from '../../static/other/announcement_icon.svg';
import jury_avatar from '../../static/other/jury-avatar.png';
import notification_sound from '../../static/other/notification_sound.mp3';

import UserAvatar from '../../components/avatar';
import MainButton, { SecondaryButton } from '../../components/buttons';
import ChatBox from '../../components/chatbox';
import { DatetimeLabeledInput, LabeledInput, TextLabeledInput, UnlabeledInput } from '../../components/inputs';
import Loader, { LoaderSmall } from '../../components/loaders';
import LoginContainer from '../../components/login';
import Markdown from '../../components/markdown';
import SelectList from '../../components/selectlist';
import Timer from '../../components/timer';
import { useDraggableInPortal } from '../../hooks/useDraggable';

import _fetchApi from '../../fetch';
import GlobalContext, { adminSubmissionDateConverter, dateConverter, juryConnectionDateConverter, titleEnding } from '../../global';
import fetchApi from "../../utils/fetchApi";

import AceEditor from 'react-ace';
import 'ace-builds/src-min-noconflict/ext-language_tools.js';
import 'ace-builds/src-min-noconflict/theme-chrome.js';
import 'ace-builds/src-min-noconflict/theme-dracula.js';
import AdminList from '../../components/adminlist';
import { TaskSearchList } from './lists/TaskSearchList';
import ArchiveUploader from './ArchiveUploader';
import SubmittedArchiveViewer from './SubmittedArchiveViewer';


export function getTaskIcon(difficulty) {
  if (difficulty < 30) {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.33279 11.666C2.7189 11.666 2.22168 11.1688 2.22168 10.5549V2.22155C2.22168 1.60766 2.7189 1.666 3.33279 1.666C3.94668 1.666 4.4439 1.60766 4.4439 2.22155C4.4439 2.22155 4.10724 5.79044 4.4439 8.88655C4.7439 11.6499 6.66612 12.2216 6.66612 12.2216C6.66612 12.8354 3.94668 11.666 3.33279 11.666ZM11.1106 14.4432C10.4967 14.4432 9.99946 13.946 9.99946 13.3321V1.66544C9.99946 1.05155 10.4967 1.10989 11.1106 1.10989C11.7245 1.10989 12.2217 1.05155 12.2217 1.66544C12.2217 1.66544 11.9739 4.50322 12.1522 6.83044C12.33 9.15655 12.2217 13.3321 12.2217 13.3321C12.2217 13.9454 11.7245 14.4432 11.1106 14.4432Z" fill="#7A5C44"/>
      <path d="M20 2.22195L0 4.44417V2.22195L20 1.11084V2.22195Z" fill="#662113"/>
      <path d="M12.5813 10.2258C12.2296 10.8514 11.8241 11.2308 11.3813 11.4442C11.158 11.467 10.7524 11.397 10.5941 10.6425C10.4096 9.76084 10.223 8.51306 10.223 6.97917C10.223 4.67695 10.5569 2.12251 10.5569 2.12251C10.5569 1.6064 11.3413 1.60251 11.7157 1.57195C11.6291 1.10973 10.7441 1.11084 9.66908 1.11084C8.86186 1.11084 8.41575 1.70751 8.33464 2.38917C8.25297 3.0714 7.8963 5.91528 7.9213 7.94473C7.93464 9.04695 8.00686 10.2564 8.0963 11.287C7.6563 11.1753 7.21575 11.0686 6.78297 11.0142C5.22352 10.8164 3.16908 10.717 2.82241 7.74695C2.54797 5.39584 2.77908 2.67806 2.77908 2.67806C2.77908 2.16195 3.56352 2.03473 3.93797 2.00417C3.8513 1.54195 3.00575 1.49806 1.93241 1.56917C1.12686 1.62251 0.687413 2.03806 0.556858 2.94473C0.346858 4.40528 0.322413 7.7714 0.445747 10.0981C0.514636 11.397 0.717969 16.0758 2.72297 17.8953C3.89408 18.9575 5.88297 19.5853 8.33464 19.4447C10.6596 19.3114 12.5696 18.447 13.6391 17.5486C15.4957 15.9892 15.9113 14.8614 15.9885 13.6403C16.1124 11.667 13.3457 8.8664 12.5813 10.2258Z" fill="#A78E81"/>
      <path d="M19.456 12.5942C18.2888 14.3725 15.9688 14.9125 13.4788 13.2786C10.9888 11.6447 10.5604 9.30141 11.7277 7.52308C12.8949 5.74475 15.8876 6.08752 17.4965 7.17641C19.1054 8.2653 20.6232 10.8159 19.456 12.5942Z" fill="#A78E81"/>
      <path d="M18.484 12.8773C17.6507 14.1478 15.6151 14.5351 13.4812 13.1351C11.3473 11.7351 11.0262 9.80117 11.8601 8.53062C12.6935 7.26007 14.2457 7.4634 16.3796 8.86395C18.5135 10.2645 19.3173 11.6073 18.484 12.8773Z" fill="#E2D2C7"/>
      <path d="M11.4261 8.09003C11.1488 8.71558 11.05 9.38781 11.1533 10.0623C11.9855 10.3061 13.1739 10.6011 13.7366 10.4839C14.6511 10.2939 14.9577 9.47447 14.8233 8.82781C14.6372 7.93003 13.0505 7.41447 11.4261 8.09003Z" fill="#292F33"/>
      <path d="M12.994 9.86981C13.3585 9.86981 13.654 9.57432 13.654 9.20981C13.654 8.8453 13.3585 8.5498 12.994 8.5498C12.6295 8.5498 12.334 8.8453 12.334 9.20981C12.334 9.57432 12.6295 9.86981 12.994 9.86981Z" fill="#F5F8FA"/>
      <path d="M19.0587 13.0999C18.5954 13.6032 18.0181 13.9616 17.3581 14.1355C16.8031 13.4694 16.0598 12.496 15.9426 11.9333C15.7526 11.0188 16.3826 10.4116 17.0293 10.2771C17.9276 10.091 19.032 11.341 19.0587 13.0999Z" fill="#292F33"/>
      <path d="M17.4129 12.7676C17.7774 12.7676 18.0729 12.4721 18.0729 12.1076C18.0729 11.7431 17.7774 11.4476 17.4129 11.4476C17.0484 11.4476 16.7529 11.7431 16.7529 12.1076C16.7529 12.4721 17.0484 12.7676 17.4129 12.7676Z" fill="#F5F8FA"/>
      <path d="M15.5788 12.4857C15.1788 13.0957 14.3599 13.2652 13.7504 12.8652C13.1404 12.4652 12.971 11.6463 13.371 11.0368C13.771 10.4268 14.2276 10.809 14.8371 11.209C15.4465 11.609 15.9788 11.8757 15.5788 12.4857Z" fill="#292F33"/>
      <path d="M15.5402 13.9586C15.5268 13.9586 15.513 13.9575 15.4996 13.9559C13.0113 13.5925 12.0013 11.6948 11.9596 11.6136C11.8896 11.4781 11.9424 11.3109 12.0785 11.2403C12.2152 11.1681 12.3818 11.2231 12.453 11.3575C12.4624 11.3748 13.3824 13.0848 15.5802 13.4059C15.7318 13.4281 15.8368 13.5692 15.8152 13.7209C15.7946 13.8592 15.6763 13.9586 15.5402 13.9586Z" fill="#292F33"/>
    </svg>;
  } else if (30 <= difficulty && difficulty < 50) {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.4961 2.56226C14.2195 2.83893 14.1467 3.02837 14.0917 3.13393C13.725 3.83726 13.2834 4.06504 12.5473 3.32893C12.475 3.2567 10.2767 0.958371 9.91337 0.541704C9.67615 0.269482 9.31281 0.186149 9.03337 0.396149C8.82226 0.555038 6.7917 2.21448 6.23615 2.90004C5.80615 3.43059 5.7917 4.08559 6.19226 4.4867C6.37337 4.66782 6.59615 4.73615 6.8317 4.80782C7.13837 4.9017 7.81115 4.84559 8.20393 5.23837C8.83337 5.86782 8.50393 6.86282 7.69448 7.69448C6.86281 8.50393 5.86781 8.83337 5.23837 8.20393C4.84504 7.81059 4.9017 7.13837 4.80781 6.8317C4.73615 6.59615 4.66781 6.37393 4.4867 6.19226C4.08615 5.7917 3.43115 5.8067 2.90004 6.23615C2.21393 6.7917 0.555036 8.82226 0.396148 9.03337C0.185592 9.31281 0.269481 9.67559 0.541703 9.91337C0.95837 10.2767 3.2567 12.475 3.32893 12.5473C4.06448 13.2828 3.83726 13.725 3.13393 14.0917C3.02837 14.1467 2.83948 14.2189 2.56226 14.4961C1.75004 15.3084 1.75004 16.6256 2.56226 17.4378C3.37448 18.25 4.6917 18.25 5.50393 17.4378C5.78059 17.1611 5.85337 16.9717 5.90837 16.8661C6.27504 16.1628 6.7167 15.935 7.45281 16.6711C7.52504 16.7434 9.72337 19.0417 10.0867 19.4584C10.3239 19.7306 10.6873 19.8139 10.9667 19.6039C11.1778 19.445 13.2084 17.7856 13.7639 17.1C14.1939 16.5695 14.2084 15.9145 13.8078 15.5134C13.6267 15.3323 13.4039 15.2639 13.1684 15.1923C12.8617 15.0984 12.1889 15.1545 11.7961 14.7617C11.1667 14.1323 11.4961 13.1373 12.3056 12.3056C13.1373 11.4961 14.1323 11.1667 14.7617 11.7961C15.155 12.1895 15.0984 12.8617 15.1923 13.1684C15.2639 13.4039 15.3323 13.6261 15.5134 13.8078C15.9139 14.2084 16.5689 14.1934 17.1 13.7639C17.7861 13.2084 19.445 11.1778 19.6039 10.9667C19.8145 10.6873 19.7306 10.3245 19.4584 10.0867C19.0417 9.72337 16.7434 7.52504 16.6711 7.45282C15.9356 6.71726 16.1628 6.27504 16.8661 5.90837C16.9717 5.85337 17.1606 5.78115 17.4378 5.50393C18.25 4.6917 18.25 3.37448 17.4378 2.56226C16.6256 1.74948 15.3084 1.74948 14.4961 2.56226Z" fill="#78B159"/>
    </svg>;
  } else if (50 <= difficulty && difficulty < 70) {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M19.8521 11.0717C19.6526 9.25558 19.4443 8.33336 18.8887 7.22225C18.8887 7.22225 20.5554 2.22225 19.4443 0.166696C19.0698 -0.525527 15.331 1.10447 13.8887 2.22225C13.8887 2.22225 11.6665 1.66781 9.99985 1.66781C8.33318 1.66781 6.11096 2.22225 6.11096 2.22225C4.66874 1.10447 0.929851 -0.525527 0.555406 0.166696C-0.555705 2.22225 1.11096 7.22225 1.11096 7.22225C0.555406 8.33336 0.347073 9.25558 0.147628 11.0717C-0.071816 13.0628 0.364851 14.65 0.555406 15C0.772073 15.3978 1.87041 16.6806 3.33318 17.7778C5.55541 19.4445 8.88874 20 9.99985 20C11.111 20 14.4443 19.4445 16.6665 17.7778C18.1293 16.6806 19.2276 15.3978 19.4443 15C19.6348 14.65 20.0715 13.0628 19.8521 11.0717Z" fill="#FFCC4D"/>
        <path d="M10.0002 10.8334C11.6668 10.8334 11.6668 11.1112 11.6668 11.6667C11.6668 12.2223 10.8335 13.3334 10.0002 13.3334C9.16683 13.3334 8.3335 12.2223 8.3335 11.6667C8.3335 11.1112 8.33294 10.8334 10.0002 10.8334Z" fill="#E75A70"/>
        <path d="M1.11112 1.66672C1.35946 0.921166 4.24446 2.22228 4.80001 2.77783C4.80001 2.77783 2.22223 4.4445 1.66668 6.11117C1.66668 6.11117 0.555566 3.33339 1.11112 1.66672ZM18.8889 1.66672C18.6406 0.921166 15.7556 2.22228 15.2 2.77783C15.2 2.77783 17.7778 4.4445 18.3333 6.11117C18.3333 6.11117 19.4445 3.33339 18.8889 1.66672Z" fill="#F18F26"/>
        <path d="M2.74121 3.11278C2.74121 2.32722 6.11121 3.88889 5.55566 4.44444C5.0001 5 4.44454 5.335 3.88899 5.89055C3.33343 6.44611 2.74121 3.66833 2.74121 3.11278ZM17.259 3.11278C17.259 2.32722 13.889 3.88889 14.4445 4.44444C15.0001 5 15.5557 5.335 16.1112 5.89055C16.6668 6.44611 17.259 3.66833 17.259 3.11278Z" fill="#FFCC4D"/>
        <path d="M0.389552 13.8889C0.30733 13.8889 0.226218 13.8527 0.171218 13.7833C0.0762185 13.6627 0.096774 13.4883 0.21733 13.3933C0.30733 13.3227 2.45066 11.66 6.13288 11.9461C6.28566 11.9572 6.40011 12.0911 6.38844 12.2439C6.37677 12.3966 6.24566 12.5222 6.09011 12.4994C2.62733 12.2361 0.581774 13.8139 0.561774 13.83C0.510107 13.8694 0.449552 13.8889 0.389552 13.8889ZM5.31622 11.2983C5.289 11.2983 5.26066 11.2944 5.23344 11.2861C2.57233 10.4544 0.379552 11.0933 0.35733 11.0994C0.210107 11.1444 0.0556629 11.0605 0.0112185 10.9133C-0.0326704 10.7661 0.0506629 10.6116 0.19733 10.5677C0.293441 10.5389 2.57844 9.87497 5.39844 10.7555C5.54511 10.8016 5.62677 10.9572 5.58066 11.1039C5.544 11.2222 5.43455 11.2983 5.31622 11.2983ZM19.6107 13.8889C19.6929 13.8889 19.774 13.8527 19.829 13.7833C19.924 13.6627 19.9034 13.4883 19.7829 13.3933C19.6929 13.3227 17.5496 11.66 13.8673 11.9461C13.7146 11.9572 13.6001 12.0911 13.6118 12.2439C13.6234 12.3966 13.7546 12.5222 13.9101 12.4994C17.3729 12.2361 19.4184 13.8139 19.4384 13.83C19.4901 13.8694 19.5507 13.8889 19.6107 13.8889ZM14.684 11.2983C14.7112 11.2983 14.7396 11.2944 14.7668 11.2861C17.4279 10.4544 19.6207 11.0933 19.6429 11.0994C19.7901 11.1444 19.9446 11.0605 19.989 10.9133C20.0329 10.7661 19.9496 10.6116 19.8029 10.5677C19.7068 10.5389 17.4218 9.87497 14.6018 10.7555C14.4551 10.8016 14.3734 10.9572 14.4196 11.1039C14.4557 11.2222 14.5657 11.2983 14.684 11.2983Z" fill="#FEE7B8"/>
        <path d="M14.0706 14.2344C13.9861 14.1611 13.8656 14.1461 13.7644 14.1961L11.5422 15.3072C10.5028 15.8267 7.805 15.8333 7.77778 15.8333C7.62444 15.8333 7.5 15.9578 7.5 16.1111C7.5 16.2139 7.55611 16.3039 7.63889 16.3517V16.3522H7.63944V16.3528C7.67889 16.375 7.72444 16.3878 7.77278 16.3889H11.6661C13.1428 16.3889 13.9378 15.1744 14.1522 14.5322C14.1878 14.4256 14.1556 14.3083 14.0706 14.2344Z" fill="#292F33"/>
        <path d="M6.66677 10.0001C7.28042 10.0001 7.77789 9.12954 7.77789 8.05565C7.77789 6.98176 7.28042 6.11121 6.66677 6.11121C6.05313 6.11121 5.55566 6.98176 5.55566 8.05565C5.55566 9.12954 6.05313 10.0001 6.66677 10.0001Z" fill="#292F33"/>
        <path d="M13.3333 10.0001C13.9469 10.0001 14.4444 9.12954 14.4444 8.05565C14.4444 6.98176 13.9469 6.11121 13.3333 6.11121C12.7196 6.11121 12.2222 6.98176 12.2222 8.05565C12.2222 9.12954 12.7196 10.0001 13.3333 10.0001Z" fill="#292F33"/>
        <path d="M11.6666 6.66671C11.5244 6.66671 11.3822 6.61226 11.2739 6.50393C11.0566 6.28671 11.0566 5.9356 11.2739 5.71837C13.6316 3.3606 16.0105 3.33337 16.1111 3.33337C16.4183 3.33337 16.6666 3.58226 16.6666 3.88893C16.6666 4.19504 16.4194 4.44337 16.1139 4.44449C16.0777 4.44504 14.0655 4.49782 12.0594 6.50393C11.9511 6.61226 11.8089 6.66671 11.6666 6.66671ZM8.3333 6.66671C8.19108 6.66671 8.04886 6.61226 7.94052 6.50393C5.92608 4.49004 3.90608 4.44449 3.88608 4.44449C3.57997 4.44115 3.3333 4.19171 3.33497 3.88615C3.33664 3.58004 3.5833 3.33337 3.88886 3.33337C3.98886 3.33337 6.3683 3.3606 8.72608 5.71837C8.9433 5.9356 8.9433 6.28671 8.72608 6.50393C8.61775 6.61226 8.47552 6.66671 8.3333 6.66671Z" fill="#292F33"/>
      </g>
    </svg>;
  } else if (70 <= difficulty && difficulty < 90) {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 10C20 15.5228 15.5228 20 10 20C4.47778 20 0 15.5228 0 10C0 4.47778 4.47778 0 10 0C15.5228 0 20 4.47778 20 10Z" fill="#DA2F47"/>
      <path d="M14.1584 16.5994C14.1334 16.5 13.5095 14.1666 10.0001 14.1666C6.4901 14.1666 5.86676 16.5 5.84176 16.5994C5.81121 16.72 5.86565 16.845 5.97343 16.9072C6.08176 16.9677 6.21732 16.9511 6.30676 16.8644C6.31732 16.8538 7.39232 15.8333 10.0001 15.8333C12.6079 15.8333 13.6834 16.8538 13.6934 16.8638C13.7468 16.9166 13.8179 16.9444 13.889 16.9444C13.9357 16.9444 13.9829 16.9327 14.0257 16.9088C14.1345 16.8466 14.189 16.7205 14.1584 16.5994ZM8.72621 8.49607C6.91787 6.68774 4.01176 6.66663 3.88899 6.66663C3.58232 6.66663 3.33399 6.91496 3.33399 7.22107C3.33343 7.52774 3.58176 7.77663 3.88843 7.77774C3.90454 7.77774 4.95787 7.79052 6.10121 8.18718C5.77176 8.54274 5.55565 9.09496 5.55565 9.72218C5.55565 10.7966 6.17732 11.6666 6.94454 11.6666C7.71176 11.6666 8.33343 10.7966 8.33343 9.72218C8.33343 9.62551 8.32287 9.53329 8.31287 9.44051C8.3201 9.44051 8.32676 9.4444 8.33343 9.4444C8.47565 9.4444 8.61787 9.38996 8.72621 9.28163C8.94343 9.0644 8.94343 8.71329 8.72621 8.49607ZM16.1112 6.66663C15.9884 6.66663 13.0829 6.68774 11.274 8.49607C11.0568 8.71329 11.0568 9.0644 11.274 9.28163C11.3823 9.38996 11.5245 9.4444 11.6668 9.4444C11.674 9.4444 11.6801 9.44051 11.6868 9.44051C11.6779 9.53329 11.6668 9.62551 11.6668 9.72218C11.6668 10.7966 12.2884 11.6666 13.0557 11.6666C13.8229 11.6666 14.4445 10.7966 14.4445 9.72218C14.4445 9.09496 14.2284 8.54274 13.899 8.18718C15.0423 7.79052 16.0957 7.77774 16.1123 7.77774C16.4184 7.77663 16.6668 7.52774 16.6662 7.22107C16.6657 6.91496 16.4179 6.66663 16.1112 6.66663Z" fill="#292F33"/>
      <path d="M16.5216 18.3334H3.47828C2.78717 18.3334 2.22217 17.7684 2.22217 17.0773V13.8889C2.22217 13.1978 2.78717 12.6328 3.47828 12.6328H16.5216C17.2127 12.6328 17.7777 13.1978 17.7777 13.8889V17.0773C17.7777 17.7684 17.2127 18.3334 16.5216 18.3334Z" fill="#292F33"/>
      <path d="M4.35586 15.1272H3.90141C3.72697 15.1272 3.64752 15 3.64752 14.8733C3.64752 14.7466 3.72697 14.62 3.90141 14.62H4.42919L4.5453 13.77C4.57141 13.58 4.65086 13.5166 4.80919 13.5166C4.93586 13.5166 5.05252 13.6005 5.05252 13.7278C5.05252 13.8072 5.05252 13.77 5.04197 13.855L4.93641 14.6205H5.44363L5.55975 13.7705C5.58586 13.5805 5.6653 13.5172 5.82363 13.5172C5.9503 13.5172 6.06697 13.6011 6.06697 13.7283C6.06697 13.8078 6.06697 13.7705 6.05641 13.8555L5.9503 14.6211H6.40475C6.57919 14.6211 6.65808 14.7483 6.65808 14.8744C6.65808 15.0011 6.57863 15.1283 6.40475 15.1283H5.87641L5.79197 15.73H6.24641C6.42086 15.73 6.49975 15.8572 6.49975 15.9839C6.49975 16.1105 6.4203 16.2372 6.24641 16.2372H5.71808L5.60197 17.0872C5.5753 17.2778 5.49586 17.3405 5.33752 17.3405C5.21086 17.3405 5.09419 17.2566 5.09419 17.1294C5.09419 17.05 5.09419 17.0872 5.10475 17.0022L5.21086 16.2366H4.70419L4.58808 17.0866C4.56141 17.2772 4.48252 17.34 4.32363 17.34C4.19697 17.34 4.0803 17.2561 4.0803 17.1289C4.0803 17.0494 4.0803 17.0866 4.09086 17.0016L4.19641 16.2361H3.74308C3.56919 16.2361 3.48975 16.1089 3.48975 15.9828C3.48975 15.8555 3.56919 15.7289 3.74308 15.7289H4.27141L4.35586 15.1272ZM4.78363 15.7289H5.2853L5.36975 15.1272H4.86808L4.78363 15.7289ZM7.34808 14.34C7.34808 13.8805 7.69141 13.4844 8.16141 13.4844C8.63141 13.4844 8.97475 13.8805 8.97475 14.34C8.97475 14.7994 8.63141 15.1905 8.16141 15.1905C7.69086 15.1911 7.34808 14.8 7.34808 14.34ZM8.43586 14.34C8.43586 14.1711 8.3353 14.0233 8.16141 14.0233C7.98697 14.0233 7.88641 14.1716 7.88641 14.34C7.88641 14.5094 7.98697 14.6522 8.16141 14.6522C8.3353 14.6522 8.43586 14.5094 8.43586 14.34ZM9.71919 13.6222C9.78808 13.4905 9.84086 13.4533 9.96252 13.4533C10.1264 13.4533 10.2742 13.585 10.2742 13.7489C10.2742 13.7911 10.2742 13.8283 10.232 13.9072L8.45752 17.2289C8.37808 17.3394 8.34641 17.4028 8.21975 17.4028C8.08252 17.4028 7.91863 17.2711 7.91863 17.1128C7.91863 17.0333 7.9503 16.96 7.97141 16.9172L9.71919 13.6222ZM9.20697 16.5216C9.20697 16.0622 9.5503 15.6661 10.0203 15.6661C10.4903 15.6661 10.8336 16.0622 10.8336 16.5216C10.8336 16.9805 10.4903 17.3716 10.0203 17.3716C9.54975 17.3722 9.20697 16.9805 9.20697 16.5216ZM10.2947 16.5216C10.2947 16.3522 10.1942 16.205 10.0197 16.205C9.8453 16.205 9.74475 16.3528 9.74475 16.5216C9.74475 16.6905 9.8453 16.8333 10.0197 16.8333C10.1942 16.8333 10.2947 16.6905 10.2947 16.5216ZM11.6759 16.96C11.6759 16.7328 11.8609 16.5478 12.0875 16.5478C12.3147 16.5478 12.4997 16.7328 12.4997 16.96C12.4997 17.1866 12.3147 17.3716 12.0875 17.3716C11.8609 17.3722 11.6759 17.1872 11.6759 16.96ZM11.7075 13.8439C11.7075 13.6222 11.8709 13.485 12.0875 13.485C12.2992 13.485 12.4681 13.6278 12.4681 13.8439V15.8772C12.4681 16.0939 12.2992 16.2361 12.0875 16.2361C11.8709 16.2361 11.7075 16.0989 11.7075 15.8772V13.8439ZM16.1953 17.4033C16.0914 17.4033 16.0264 17.3739 15.9559 17.2944L15.5536 16.8555L15.5136 16.8922C15.1236 17.2505 14.787 17.4028 14.3892 17.4028C13.7731 17.4028 13.1509 17.0516 13.1509 16.2672C13.1509 15.6522 13.6325 15.2844 13.9197 15.12L13.9847 15.0828L13.932 15.0283C13.6959 14.7811 13.5992 14.5766 13.5992 14.3233C13.5992 13.725 14.1453 13.4528 14.6525 13.4528C15.077 13.4528 15.6747 13.7044 15.6747 14.2628C15.6747 14.7911 15.1842 15.0966 15.0342 15.1778L14.9703 15.2122L15.6153 15.9572L15.862 15.6594C15.9992 15.4944 16.0792 15.425 16.2209 15.425C16.3347 15.425 16.4564 15.5272 16.4564 15.7155C16.4564 15.8566 16.3164 16.0405 16.1792 16.2016L16.0142 16.3878L16.4064 16.8533C16.4792 16.94 16.5092 16.9861 16.5092 17.0911C16.5097 17.255 16.3597 17.4033 16.1953 17.4033ZM14.2803 15.4733C14.0425 15.6328 13.8003 15.8428 13.8003 16.1905C13.8003 16.555 14.0375 16.79 14.4053 16.79C14.712 16.79 14.9103 16.6555 15.1136 16.4533L15.1531 16.415L14.3197 15.4466L14.2803 15.4733ZM14.6531 13.9672C14.4975 13.9672 14.2809 14.0944 14.2809 14.3016C14.2809 14.495 14.3759 14.6128 14.5775 14.8178L14.6059 14.8466L14.6409 14.8283C14.917 14.6839 15.057 14.5211 15.057 14.3455C15.0575 14.0855 14.8481 13.9672 14.6531 13.9672Z" fill="white"/>
    </svg>; 
  } else if (90 <= difficulty) {
    return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.2223 6.66663L16.4378 12.3527L4.08505 20L2.77783 15.5555L17.2223 6.66663Z" fill="#C1694F"/>
      <path d="M0.555664 12.2222V16.4705L4.08511 19.9999V15.5555L0.555664 12.2222Z" fill="#662113"/>
      <path d="M18.8891 2.77783V7.05894L16.438 12.3528V8.33339L17.2224 5.00005L18.8891 2.77783Z" fill="#A04E3C"/>
      <path d="M18.889 2.77778L16.4379 8.23556L4.08511 15.8822L0.555664 12.2222L9.96733 1.17667L15.8496 0L18.889 2.77778Z" fill="#D99E82"/>
      <path d="M6.66737 16.6666C6.48792 16.6666 6.31181 16.5799 6.20459 16.4194C6.03459 16.1638 6.10348 15.8194 6.35848 15.6488L8.02515 14.5377C8.28015 14.3671 8.62515 14.436 8.7957 14.6916C8.9657 14.9471 8.89681 15.2916 8.64181 15.4621L6.97515 16.5732C6.88015 16.636 6.77292 16.6666 6.66737 16.6666ZM12.7785 12.7777C12.599 12.7777 12.4224 12.691 12.3157 12.5305C12.1451 12.2749 12.214 11.9305 12.4696 11.7599L14.1363 10.6488C14.3924 10.4788 14.7363 10.5477 14.9068 10.8027C15.0774 11.0582 15.0085 11.4027 14.7529 11.5732L13.0863 12.6844C12.9913 12.7471 12.884 12.7777 12.7785 12.7777Z" fill="#FFAC33"/>
      <path d="M4.9997 13.8889C4.85637 13.8889 4.71415 13.8333 4.60637 13.7261L2.9397 12.0594C2.72748 11.8472 2.72193 11.5055 2.92748 11.2866L11.2608 2.39774C11.3441 2.30885 11.4547 2.24997 11.5747 2.22997L14.908 1.67441C15.083 1.64441 15.2647 1.70219 15.3919 1.82941L16.503 2.94052C16.6608 3.09774 16.7091 3.3333 16.6269 3.53997L15.5158 6.31774C15.4769 6.41552 15.4108 6.49997 15.3253 6.56163L5.32526 13.7839C5.22748 13.8544 5.11359 13.8889 4.9997 13.8889ZM4.10637 11.6544L5.05804 12.6061L14.5441 5.75497L15.4586 3.46663L14.8091 2.81663L11.943 3.29441L4.10637 11.6544Z" fill="#C1694F"/>
    </svg>;
  }
}

const upload_icon = <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fillRule="evenodd" clipRule="evenodd" d="M10 0C10.2652 0 10.5196 0.105357 10.7071 0.292893L15.7071 5.29289C15.8946 5.48043 16 5.73478 16 6V7C16 7.55228 15.5523 8 15 8H9C8.48716 8 8.06449 7.61396 8.00673 7.11662L8 7L7.999 2H3C2.44772 2 2 2.44772 2 3V17C2 17.5523 2.44772 18 3 18H5C5.55228 18 6 18.4477 6 19C6 19.5523 5.55228 20 5 20H3C1.34315 20 0 18.6569 0 17V3C0 1.34315 1.34315 0 3 0H10ZM13 10C13.5523 10 14 10.4477 14 11V14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H14V19C14 19.5523 13.5523 20 13 20C12.4477 20 12 19.5523 12 19V16H9C8.44771 16 8 15.5523 8 15C8 14.4477 8.44771 14 9 14H12V11C12 10.4477 12.4477 10 13 10ZM9.999 2.414L10 6H13.586L9.999 2.414Z" fill="#888888"/>
</svg>;

const copy_icon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M2.6998 12.5998L2.80476 12.5937C3.21794 12.5458 3.54576 12.2179 3.59375 11.8048L3.5998 11.6998V3.5998H11.6998L11.8048 3.59375C12.2524 3.54176 12.5998 3.16136 12.5998 2.6998C12.5998 2.23825 12.2524 1.85785 11.8048 1.80586L11.6998 1.7998H2.6998L2.59485 1.80586C2.18167 1.85385 1.85385 2.18167 1.80586 2.59485L1.7998 2.6998V11.6998L1.80586 11.8048C1.85385 12.2179 2.18167 12.5458 2.59485 12.5937L2.6998 12.5998ZM15.2998 16.1998L15.4048 16.1937C15.8179 16.1458 16.1458 15.8179 16.1937 15.4048L16.1998 15.2998V6.2998L16.1937 6.19485C16.1498 5.8161 15.8706 5.50908 15.5062 5.42357L15.4048 5.40586L15.2998 5.3998H6.2998L6.19485 5.40586C5.78167 5.45385 5.45385 5.78167 5.40586 6.19485L5.3998 6.2998V15.2998L5.40586 15.4048C5.44985 15.7835 5.72898 16.0905 6.09344 16.176L6.19485 16.1937L6.2998 16.1998H15.2998ZM7.1998 7.1998V14.3998H14.3998V7.1998H7.1998Z" /></svg>;

/*
  Renders the editor's bottom strip (the "chin") with the language select passed as children.
  While the editor is empty, a click/drop zone covers its lower part (mouse devices only, see Tasks.css);
  on touch devices the chin gets a "Загрузить файл" button instead.
*/
function MyDropzone({ callback, isEmpty, children }) {
  const [status, setStatus] = useState("waiting");

  const onDrop = useCallback(acceptedFile => {
    acceptedFile.forEach(file => {
      setStatus("uploading");

      const format = file.name.split('.').pop();
      const reader = new FileReader();

      reader.onabort = () => setStatus("aborted");
      reader.onerror = () => setStatus("error");
      reader.onload = () => {
        const result = reader.result;
        callback(result, format);
        setStatus("waiting");
      }
      reader.readAsText(file, "UTF-8");
    });
  }, [callback]);

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    onDropRejected: () => setStatus("aborted"),
    multiple: false,
    maxSize: 1024 * 1024, // source code only: a huge/binary file would freeze the editor
  });

  return <>
    {isEmpty && <div {...getRootProps({ id: "file-uploader", })}>
      {upload_icon}
      {isDragActive ?
        <p>Отпускайте!</p> :
        status === "waiting" ? <p>Щелкните или перетащите файл сюда для загрузки</p> :
        status === "uploading" ? <p>Загружаем...</p> :
        <p>Загрузка прервана. Загрузите новый файл</p>
      }
    </div>}
    <div className="editor-chin">
      <input {...getInputProps()} />
      <button type="button" className="editor-upload-button" onClick={open}>
        {upload_icon}
        {status === "uploading" ? "Загружаем..." : "Загрузить файл"}
      </button>
      {children}
    </div>
  </>;
}

// Lottie animation + a random tip; shared by the "checking" loader and the contest countdown.
function TipLoader({ children, fallbackTip = "" }) {
  const [tip, setTip] = useState("");
  const context = useContext(GlobalContext);

  function getTip() {
    _fetchApi("/getRandomTip", context.token ? {
      method: "GET",
      headers: {"Authorization": "Bearer " + context.token,},
    } : {method: "GET",}).then(response => response.text()).then(result => {
      if (result === "Too Many Requests") {
        const tips = ["Не кликайте так быстро!", "Если много кликать, серверу может надоесть давать вам советы", "В Cookie Clicker не наигрались?"];
        setTip(tips[Math.floor(Math.random() * tips.length)]);
      } else {
        setTip(result);
      }
    }).catch(() => {});
  }

  useEffect(() => {
    getTip();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="loader-container">
    <Lottie options={ {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        },
      } }
      height={150}
      width={150}
    />
    <p>{children}</p>
    <div className="tip-container">
      <p className="tip">Совет: {tip || fallbackTip}</p>
    </div>
    <Button disableElevation disableRipple className="more-tip" onClick={() => getTip()}>
      <div className="more-tip-content">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M7.53677 4.00628L9.25105 2.25628C9.58579 1.91457 10.1285 1.91457 10.4632 2.25628C10.7722 2.57171 10.796 3.06803 10.5345 3.41129L10.4632 3.49372L10.11 3.8546C12.8934 4.38607 15 6.8794 15 9.875C15 13.2577 12.3137 16 9 16C5.68629 16 3 13.2577 3 9.875C3 8.95566 3.19913 8.06343 3.57772 7.24978C3.78083 6.81327 4.29212 6.62749 4.71972 6.83483C5.14732 7.04217 5.32931 7.56411 5.1262 8.00062C4.85621 8.58088 4.71429 9.21678 4.71429 9.875C4.71429 12.2912 6.63307 14.25 9 14.25C11.3669 14.25 13.2857 12.2912 13.2857 9.875C13.2857 7.98655 12.1136 6.37755 10.4716 5.76473C10.7979 6.10784 10.795 6.65505 10.4632 6.99372C10.1542 7.30914 9.66805 7.33341 9.3318 7.06651L9.25105 6.99372L7.53677 5.24372C7.22778 4.92829 7.20401 4.43197 7.46546 4.08871L7.53677 4.00628L9.25105 2.25628L7.53677 4.00628Z" fill="var(--button-color)" style={ {filter: "none", transition: "fill var(--transition-timing) var(--transition-function)",} } />
        </svg>
        <p>Ещё совет</p>
      </div>
    </Button>
  </div>;
}

const WebSocketLoader = React.memo(({ text }) => <TipLoader
  fallbackTip="Если вы успеваете прочитать данное сообщение полностью, то, возможно, у вас медленный интернет, или у нас на сервере что-то сломалось :)"
>{text ?? "Решение проверяется..."}</TipLoader>);

const ContestWaitLoader = React.memo(({ countdown_until, onExpire, now }) => <TipLoader>
  До начала: <Timer expiryTimestamp={countdown_until} onExpire={onExpire} now={now}/>
</TipLoader>);

class Task extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.submitted_ref = React.createRef();
    this.alert_ref = React.createRef();

    this.sockets = {};

    this.search_context = new URLSearchParams(window.location.search);

    this.state = {
      task_data: undefined,
      available_verbose: ["Загрузка..."],
      available_api: [],
      available_highlight: [],
      extensions: [],
    };
  }

  componentDidMount() {
    document.title = "Задача" + titleEnding;

    this.getTaskContent();
  }

  updateSubmitted() {
    this.submitted_ref.current.updateContent(true);
  }

  showSubmission(id) {
    this.alert_ref.current.updateContent(id);
  }

  refreshPage() {
    this.props.refreshPage();
  }

  establishWebsocket(id) {
    if (!Object.keys(this.sockets).includes(id.toString())) {
      let socket = new WebSocket(`wss://api.sort-me.org/ws/submission?id=${id}&token=${this.context.token}`);
      this.sockets[id] = socket;
      socket.onmessage = event => {
        if (isNaN(event.data))  {
          const data = JSON.parse(event.data);
          this.alert_ref.current.updateFromSocket(data, id);
          this.submitted_ref.current.updateFromSocket(data, id);
          delete this.sockets[id];
        } else if (parseInt(event.data) !== 0) {
          this.alert_ref.current.updateShownTest(parseInt(event.data), id);
          this.submitted_ref.current.updateShownTest(parseInt(event.data), id);
        }
      };
    }
  }

  getTaskContent() {
    const loadHighlighters = async langs => {
      for (const lang of langs.highlight) {
        await import(`ace-builds/src-min-noconflict/mode-${lang}`);
      }

      this.setState({
        available_verbose: langs.verbose,
        available_api: langs.api,
        available_highlight: langs.highlight,
        extensions: langs.extensions,
      });
    }

    // Task from Archive
    if (this.search_context.get("archive")) {
      let response = _fetchApi(`/getArchiveById?id=${this.search_context.get("archive")}`, this.context.token ? {
        method: "GET",
        headers: {"Authorization": "Bearer " + this.context.token,},
      } : {method: "GET",}).then(response => response.json());
      response.then(result => {
        if (result.hasOwnProperty("error")) {
          this.setState({
            task_data: "bad_data",
          }, () => document.title = "Задача не найдена" + titleEnding);
        } else {
          result["type"] = "archive";
          this.setState({
            search: result,
          });
          if (this.search_context.get("result") && this.props.params.id === "result") {
            this.setState({
              task_data: { id: "result" + this.search_context.get("result"), source_contest: parseInt(this.search_context.get("result")), },
            }, () => document.title = "Результаты" + titleEnding);
          } else if (this.props.params.id === "result") {
            this.setState({
              task_data: "bad_data",
            }, () => document.title = "Задача не найдена" + titleEnding);
          } else {
            const first_task_id = parseInt(this.props.params.id) || result.seasons[0].tasks[0].id;
            let response = _fetchApi(`/getTaskById?id=${first_task_id}`, this.context.token ? {
              method: "GET",
              headers: {"Authorization": "Bearer " + this.context.token,},
            } : {method: "GET",}).then(response => response.json());
            response.then(result => {
              if (result.hasOwnProperty("error")) {
                this.setState({
                  task_data: "bad_data",
                }, () => document.title = "Задача не найдена" + titleEnding);
              } else {
                this.setState({
                  task_data: result.task,
                }, () => document.title = result.task.name + titleEnding);

                loadHighlighters(result.langs);
              }
            });
          }
        }
      });

    // Normal Task
    } else {
      const response = fetchApi({
        url: "/getTaskById",
        method: "get",
        params: {
          "id": this.props.params.id,
          "similar": this.props.location.state ? 0 : 1,
        },
      }).catch(error => {
        return { error: error, }
      });
      response.then(result => {
        if (result.hasOwnProperty("error")) {
          this.setState({
            task_data: "bad_data",
          }, () => document.title = "Задача не найдена" + titleEnding);
        } else {
          if (this.props.location.state) {
            if (this.props.location.state.category === "private") {
              fetchApi({
                url: "/getManagedTasks",
                method: "get",
                params: this.props.location.state.search ? {
                  "text": this.props.location.state.search,
                } : this.props.location.state,
              }).then(previewsResult => {
                this.setState({
                  task_data: result.task,
                  search: {
                    type: "preview",
                    values: previewsResult.tasks,
                  }
                }, () => document.title = result.task.name + titleEnding);
              });
            } else {
              fetchApi({
                url: this.props.location.state.query ? "/getTaskPreviewsByText" : "/getTaskPreviews",
                method: "get",
                params: {
                  ...this.props.location.state,
                }
              }).then(previewsResult => {
                this.setState({
                  task_data: result.task,
                  search: {
                    type: "preview",
                    values: previewsResult.task_previews,
                  }
                }, () => document.title = result.task.name + titleEnding);
              });
            }
          } else {
            this.setState({
              task_data: result.task,
              search: {
                type: "preview",
                values: result.similar,
              },
            }, () => document.title = result.task.name + titleEnding);
          }

          loadHighlighters(result.langs);
        }
      });
    }
  }

  updateTaskDataOnly(id) {
    if (Object.prototype.toString.call(id) === "[object String]" && id.startsWith("result")) {
      const source = id.slice(6);
      this.setState({
        task_data: { id: id, source_contest: source, },
      }, () => document.title = "Результаты" + titleEnding);
    } else {
      document.title = "Задача" + titleEnding;
      this.setState({task_data: undefined,});
      this.submitted_ref.current.setState({submitted: undefined,});
      let response = _fetchApi(`/getTaskById?id=${id}`, this.context.token ? {
        method: "GET",
        headers: {"Authorization": "Bearer " + this.context.token,},
      } : {method: "GET",}).then(response => response.json());
      response.then(result => {
        if (result.hasOwnProperty("error")) {
          this.setState({
            task_data: "bad_data",
          }, () => document.title = "Задача не найдена" + titleEnding);
        } else {
          this.setState({
            task_data: result.task,
            available_verbose: result.langs.verbose,
            available_api: result.langs.api,
            available_highlight: result.langs.highlight,
            extensions: result.langs.extensions,
          }, () => document.title = result.task.name + titleEnding);
        }
      });
    }
  }

  componentWillUnmount() {
    Object.values(this.sockets).forEach(socket => socket.close(1000));
    this.sockets = {};
  }

  render() {
    return <div className="task-layout">
      <aside className="task-sidebar">
        <div className="task-sidebar-sticky">
          <TaskSearchList {...this.props}
            task_data={this.state.task_data}
            refreshPage={() => this.refreshPage()}
            search={this.state.search}
            updateTaskData={id => this.updateTaskDataOnly(id)}
          />
        </div>
      </aside>
      <div className="task-container">
        <TaskContent {...this.props}
          task_data={this.state.task_data}
          updateSubmitted={() => this.updateSubmitted()}
          available_verbose={this.state.available_verbose}
          available_api={this.state.available_api}
          available_highlight={this.state.available_highlight}
          extensions={this.state.extensions}
        />
        <TaskSubmitted {...this.props}
          task_data={this.state.task_data}
          showSubmission={id => this.showSubmission(id)}
          establishWebsocket={id => this.establishWebsocket(id)}
          ref={this.submitted_ref}
        />
      </div>
      <TaskAlert {...this.props}
        task_data={this.state.task_data}
        ref={this.alert_ref}
        available_verbose={this.state.available_verbose}
        available_api={this.state.available_api}
        available_highlight={this.state.available_highlight}
      />
    </div>;
  }
}

class TaskContent extends React.PureComponent {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.editor_ref = React.createRef();

    this.state = {
      verbose_mode: undefined,
      api_mode: undefined,
      highlight_mode: undefined,
      index: 0,
      has_code: false,
      // jury communication
      announcements: [],
      messages: [],
    }

    this.jury_socket = null;
  }

  componentWillUnmount() {
    clearTimeout(this.preload_timeout);
  }

  componentDidUpdate(prev_props) {
    if (this.state.highlight_mode === undefined && this.props.available_highlight.length > 0) {
      const lang = window.localStorage.getItem("last_selected_lang");
      let index = this.props.available_api.indexOf(lang);
      index = index >= 0 ? index : 0;

      this.setState({
        verbose_mode: this.props.available_verbose[index],
        api_mode: this.props.available_api[index],
        highlight_mode: this.props.available_highlight[index],
        index: index,
      }); 
    }

    if (prev_props.task_data && !this.props.task_data && this.state.has_code) {
      this.setState({has_code: false,});
    }
  }

  render() {
    switch (this.props.task_data) {
      case undefined:
        return <div className="task-content"><Loader /></div>;
      case "bad_data":
        return <div className="task-content">
          <h2>Упс... Такой задачи у нас пока нет</h2>
        </div>;
      case "bad_contest_data":
        return <div className="task-content">
          <h2>Упс... Такого контеста у нас пока нет</h2>
          {this.context.login ? <p>Возможно, контест есть, но у вас нет к нему доступа.</p> :<>
            <p>Возможно, вам нужно авторизироваться, чтобы участвовать в контесте.</p>
            <LoginContainer title="Войдите, чтобы просматривать контесты" />
          </>}
        </div>;
      case "waiting":
        return <div className="contest-task-wait-loader">
          <ContestWaitLoader 
            onExpire={() => this.props.onTimerExpire()}
            now={this.props.timer_now}
            countdown_until={this.props.timer_countdown_until}
          />
        </div>;
      case "rating":
        return <ContestRating
          {...this.props}
        />;
      case "announcements":
        // fall through
      case "messages":
        return <></>;
      case "admin":
        return <AdminPage
          {...this.props}
        />;
      default:
        if (this.props.task_data.hasOwnProperty("source_contest"))  {
          return <ContestRating
            key={this.props.task_data.source_contest}
            archived={true}
            params={{ contest_id: this.props.task_data.source_contest, }}
          />;
        } else {
          return <div className="task-content">
            <h2>{this.props.task_data.name}</h2>
            {this.props.task_data.difficulty !== 0 && <div style={ {display: "flex", alignItems: "center", marginTop: "18px",} }>
              {getTaskIcon(this.props.task_data.difficulty)}
              <p className="difficulty">Сложность: {this.props.task_data.difficulty}%</p>
            </div>}
            <div className="task-text-block">
              <Markdown>{this.props.task_data.main_description === "empty" ? "" : this.props.task_data.main_description}</Markdown>
            </div>
            <div className="task-text-block">
              <p className="task-category-header">Входные данные</p>
              <Markdown>{this.props.task_data.in_description === "empty" ? "" : this.props.task_data.in_description}</Markdown>
            </div>
            <div className="task-text-block">
              <p className="task-category-header">Выходные данные</p>
              <Markdown>{this.props.task_data.out_description === "empty" ? "" : this.props.task_data.out_description}</Markdown>
            </div>
            {this.props.task_data.hasOwnProperty("rating_system") && this.props.task_data.rating_system !== "empty" ? 
              <div className="task-text-block">
                <p className="task-category-header">Система оценки</p>
                <Markdown>{this.props.task_data.rating_system}</Markdown>
              </div>
            : ""}
            { this.props.task_data.hasOwnProperty("subtasks") ? 
              <div className="task-text-block">
                <p className="task-category-header">Подзадачи</p>
                <div className="subtask-table-scroll"><table cellSpacing="0" className="subtask-table"><tbody>
                  <tr className="subtask-header">
                    <td>№</td>
                    <td>баллы</td>
                    <td>необх. подзадачи</td>
                    <td>ограничения</td>
                  </tr>
                  { this.props.task_data.subtasks.map((element, index) => {
                    const bar = <svg width="6" height="20" viewBox="0 0 2 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0V20" stroke="var(--subtask-stroke)" /></svg>;
                    return <tr className="subtask-item" key={index}>
                      <td>{element.num}</td>
                      <td><div className="subtask-item-container">{bar}<p>{element.points}</p></div></td>
                      <td><div className="subtask-item-container">{bar}<p>{element.hasOwnProperty("necessary_subtasks") ? element.necessary_subtasks.join(", ") : "-"}</p></div></td>
                      <td><div className="subtask-item-container">{bar}<Markdown>{element.description}</Markdown></div></td>
                    </tr>;
                  }) }
                </tbody></table></div>
              </div>
            : "" }
            <div className="task-text-block samples">
              {this.props.task_data.samples.map((element, index) => <div className="samples-item" key={index}>
                {[["STDIN", element.in], ["STDOUT", element.out]].map(([label, text]) => <div className="samples-cell" key={label}>
                  <p className="samples-label">{label}</p>
                  <div className="samples-box">
                    <pre>{text}</pre>
                    <button
                      type="button"
                      className="samples-copy-button"
                      aria-label={"Скопировать " + label}
                      title="Скопировать"
                      onClick={event => {
                        const box = event.currentTarget.parentElement;
                        box.classList.add("samples-blinking");
                        setTimeout(() => box.classList.remove("samples-blinking"), 250);
                        navigator.clipboard?.writeText(text);
                      }}
                    >{copy_icon}</button>
                  </div>
                </div>)}
              </div>)}
            </div>
            { this.props.task_data.hasOwnProperty("comment") && this.props.task_data.comment !== "empty" ? 
              <div className="task-text-block task-text-addition">
                <p className="task-category-header">Примечание</p>
                <Markdown>{this.props.task_data.comment}</Markdown>
              </div>
            : "" }
            { this.context.login == null ? <LoginContainer id="task-login" title={"Войдите или зарегайтесь, чтобы сдать задачу"} /> : <>
              <div className="task-submit-area">
              {this.props.timer_now && !this.props.timer_countdown_until /* эквивалентно закончившемуся контесту, ведь тогда this.props.timer_countdown_until = null */ ? <div className="contest-submit-blocker">
                  <h2 className="header">А всё уже, а надо было раньше...</h2>
                  <p>Соревнование завершено.<br />Если организатор разрешит, задачи можно будет дорешать в архиве.</p>
              </div> : <></>}
              {this.props.task_data?.open_tests ? <ArchiveUploader
                taskId={this.props.task_data.id}
                contestId={this.props.params.contest_id}
                limits={{
                  time: this.props.task_data.time_limit_milliseconds,
                  memory: this.props.task_data.memory_limit_megabytes,
                }}
                submitCallback={this.props.updateSubmitted}
              /> : <>
                <div className={clsx("task-editor", !this.state.has_code && "is-empty")}>
                  <GlobalContext.Consumer>
                    {() => <AceEditor
                      ref={this.editor_ref}
                      width="100%"
                      onChange={ value => this.setState({has_code: value ? true : false}) }
                      mode={this.state.highlight_mode || "text" /* built in; "" would make Ace fetch a missing mode-mode.js */}
                      theme={this.context.theme === "light" ? "chrome" : "dracula"}
                      className="code-editor preload"
                      name="main-editor"
                      editorProps= { {$blockScrolling: true,} }
                      placeholder="Наберите код..."
                      fontSize="16px"
                      enableBasicAutocompletion={true}
                      highlightActiveLine={false}
                      setOptions={ {
                        enableBasicAutocompletion: true,
                        wrap: true,
                        showPrintMargin: false,
                        maxLines: 19,
                      } }
                      onLoad={ editor => {
                        editor.renderer.setPadding(12);
                        editor.renderer.setScrollMargin(12, 2);
                        this.preload_timeout = setTimeout(() => editor.container.classList.remove("preload"), 200);
                      } }
                    />}
                  </GlobalContext.Consumer>
                  <MyDropzone isEmpty={!this.state.has_code} callback={(code, format) => {
                    if (!this.props.extensions[this.state.index].includes(format)) {
                      for (let i = 0; i < this.props.extensions.length; i++) {
                        if (this.props.extensions[i].includes(format)) {
                          this.setState({
                            index: i,
                            verbose_mode: this.props.available_verbose[i],
                            api_mode: this.props.available_api[i],
                            highlight_mode: this.props.available_highlight[i],
                          });
                          break;
                        }
                      }
                    }
                    this.editor_ref.current.editor.focus();
                    this.editor_ref.current.editor.setValue(code, 1); // cursor to the end instead of selecting everything
                  }}>
                    <SelectList id="mode-selector" index={this.state.index} options={this.props.available_verbose} onChange={
                      (new_value, index) => {
                        window.localStorage.setItem("last_selected_lang", this.props.available_api[index]);
                        this.setState({
                          verbose_mode: new_value,
                          api_mode: this.props.available_api[index],
                          highlight_mode: this.props.available_highlight[index],
                          index: index,
                        });
                      }} />
                  </MyDropzone>
                </div>
                <div className="task-send-block">
                        <MainButton disabled={!this.state.has_code} id="send-task" onClick={ async () => {
                          let completed = true;
                          let response = await _fetchApi("/submit", {
                            method: "POST",
                            headers: {"Authorization": "Bearer " + this.context.token,
                                      "Content-Type": "application/json",},
                            body: JSON.stringify(isNaN(this.props.params.contest_id) ? {
                              "task_id": parseInt(this.props.task_data.id),
                              "lang": this.state.api_mode,
                              "code": this.editor_ref.current.editor.getValue(),
                            } : {
                              "task_id": parseInt(this.props.task_data.id),
                              "lang": this.state.api_mode,
                              "code": this.editor_ref.current.editor.getValue(),
                              "contest_id": parseInt(this.props.params.contest_id) || 0,
                            }),
                          }).then(response => {
                            if (!response.ok) {
                              completed = false;
                            }
                            return response;
                          });

                            if (!completed) {
                              return { completed: false, status: response.status };
                            }

                            response = await response.json();
                            // this.editor_ref.current.editor.setValue("");
                            this.props.updateSubmitted(response.id);
                            return response;
                          } }>Отправить</MainButton>
                        <div className="task-limits">
                          <p>Лимит времени: {this.props.task_data.time_limit_milliseconds} мс</p>
                          <p>Лимит памяти: {this.props.task_data.memory_limit_megabytes} мб</p>
                        </div>
                </div>
              </>}
              </div>
              {this.props.task_data?.is_admin && <Link to={`/tasks/${this.props.task_data.id}/easy-edit`} className="task-edit-link" onClick={() => window.scrollTo({ top: 0, left: 0, })}>
                  <button>Редактировать задачу</button>
              </Link>}
            </>}
          </div>;
        }
    }
  }
}

// Props for a table row that opens something: clickable, and reachable/activatable from the keyboard too
function clickableRow(onActivate) {
  return {
    role: "button",
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onActivate();
      }
    },
  };
}

class TaskSubmitted extends React.Component {
  static contextType = GlobalContext;
  
  constructor(props) {
    super(props);

    this.state = {
      submitted: undefined,
    }

    this.known_submissions = {};
    this.known_submissions_on_check = {};

    this.list_ref = React.createRef();
    this.fetching_id = null; // id of the task whose submissions are being fetched
  }

  componentDidUpdate(prev_props, prev_state) {
    if (Object.prototype.toString.call(this.props.task_data) === '[object String]' && this.state.submitted === undefined) {
      this.setState({submitted: null,});
    } else if (this.context.login != undefined && this.props.task_data !== undefined && this.props.task_data !== "bad_data" && this.state.submitted === undefined && this.fetching_id !== this.props.task_data.id) {
      this.updateContent(false);
    }

    // Follow the submissions that are still being judged
    if (this.state.submitted && this.state.submitted !== prev_state.submitted) {
      for (const element of this.state.submitted) {
        if (element.shown_verdict === 0) {
          this.props.establishWebsocket(element.id);
          this.known_submissions_on_check[element.id] = this.props.task_data.id;
        }
      }
    }
  }

  // The list is the right column on desktop and sits below the editor on smaller screens
  scrollToList() {
    this.list_ref.current?.scrollIntoView({ behavior: "smooth", block: "start", });
  }

  updateFromSocket(data, id) {
    let new_state = this.state.submitted.map((element, index) => {
      if (element.id === id) {
        const new_submission = {
          id: id,
          shown_test: data.shown_test,
          shown_verdict: data.shown_verdict,
          shown_verdict_text: data.shown_verdict_text,
          total_points: data.total_points,
        };
        this.known_submissions[this.known_submissions_on_check[id]].submissions[index] = new_submission;
        return new_submission
      } else {
        return element
      }
    });
    this.setState({submitted: new_state,});
  }

  updateShownTest(test_number, id) {
    if (this.state.submitted) {
      let new_state = this.state.submitted.map((element, index) => {
        if (element.id === id) {
          let new_submission = element;
          new_submission["shown_test"] = test_number;
          new_submission["shown_verdict_text"] = "Проверяется...";
          this.known_submissions[this.known_submissions_on_check[id]].submissions[index] = new_submission;
          return new_submission
        } else {
          return element
        }
      });
      this.setState({submitted: new_state,});
    }
  }

  updateContent(scroll) {
    const requested_id = this.props.task_data.id;
    if (!scroll && this.props.location.pathname.startsWith("/contest") && this.known_submissions.hasOwnProperty(requested_id)) {
      const result = this.known_submissions[requested_id];
      this.setState({
        submitted: result.submissions,
        count: result.count,
        button_text: "Показать ещё",
      });
    } else {
      this.fetching_id = requested_id;
      _fetchApi(`/getMySubmissionsByTask?id=${requested_id}${this.props.location.pathname.startsWith("/contest") ? "&contestid=" + this.props.params.contest_id : ""}`, {
        method: "GET",
        headers: {"Authorization": "Bearer " + this.context.token,},
      }).then(response => response.json()).then(result => {
        if (!result.hasOwnProperty("error")) {
          this.known_submissions[requested_id] = result;
          if (this.props.task_data?.id == requested_id || this.props.task_data?.id === "0") {
            this.setState({
              submitted: result.submissions,
              count: result.count,
              button_text: "Показать ещё",
            }, () => scroll && this.scrollToList());
          }
        }
      }).catch(() => {}).finally(() => {
        if (this.fetching_id === requested_id) {
          this.fetching_id = null;
        }
      });
    }
  }

  showMore() {
    if (this.state.button_text === "Показать ещё") {
      const requested_id = this.props.task_data.id;
      this.setState({ button_text: <LoaderSmall height={22} width={22} />, });
      let response = _fetchApi(`/getMySubmissionsByTask?id=${requested_id}&offset=${this.state.submitted[this.state.submitted.length - 1].id}${this.props.location.pathname.startsWith("/contest") ? "&contestid=" + this.props.params.contest_id : ""}`, {
        method: "GET",
        headers: {"Authorization": "Bearer " + this.context.token,},
      }).then(response => response.json());
      response.then(result => {
        if (this.props.task_data.id == requested_id) {
          this.setState({
            submitted: this.state.submitted.concat(result.submissions),
            button_text: "Показать ещё",
          });
        }
      });
    }
  }

  appendSubmission(id, task_id) {
    const known = this.known_submissions[task_id];
    if (!known?.submissions) { // the list of this task was never loaded: just load it
      this.updateContent(true);
      return;
    }

    known.submissions.unshift({id: id, shown_verdict: 0, shown_verdict_text: "В очереди"});
    known.count++;
    known.submissions.length >= 11 && known.submissions.pop();
    this.known_submissions_on_check[id] = task_id;

    this.setState({
      submitted: [...known.submissions],
      count: known.count,
      button_text: "Показать ещё",
    }, () => this.scrollToList());
  }

  render() {
    if (this.state.submitted?.length > 0 && !this.props.task_data?.hasOwnProperty?.("source_contest")) {
      return <div className="task-submitted" ref={this.list_ref}>
        <p className="task-category-header">Мои попытки</p>
        <table cellSpacing="0" className="submissions-table"><tbody>
          <tr className="subtask-header">
            <td>Баллы</td>
            <td>Вердикт</td>
            <td>Тест</td>
          </tr>
          { this.state.submitted.map((element, index) => {
            const bar = <svg width="6" height="20" viewBox="0 0 2 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0V20" stroke="var(--subtask-stroke)" /></svg>;
            let color;
            if (element.hasOwnProperty("total_points")) {
              switch (element.total_points) {
                case (100):
                  color = "submisson-green";
                  break;
                case (0):
                  color = "submisson-red";
                  break;
                default:
                  color = "submisson-black";
              }
            } else {
              if (element.shown_verdict === 0) {
                color = "submisson-black";
              } else {
                color = "submisson-red";
              }
            }

            return <tr className={"subtask-item " + color} key={index} id={"submission-" + element.id} {...clickableRow(() => this.props.showSubmission(element.id))}>
              <td><p>{element.shown_verdict !== 5 && element?.total_points}</p></td>
              <td><div className="subtask-item-container">{bar}<p>{element.shown_verdict_text}</p></div></td>
              <td><div className="subtask-item-container">{bar}<p>{element.hasOwnProperty("shown_test") ? (element.shown_test == 0 ? "" : element.shown_test) : ""}</p></div></td>
            </tr>;
          }) }
        </tbody></table>
        {this.state.count > this.state.submitted.length ? <Button disableElevation disableRipple className="task-show-more" onClick={() => this.showMore()}>{this.state.button_text}</Button> : ""}
      </div>;
    } else {
      return <></>;
    }
  }
}

function Separator() {
  return <hr className="task-alert-separator" />;
}

function DeniedInfo(props) {
  return <div className="task-alert-block">
    <p className="alert-category-header">Упс... Что-то пошло не так</p>
    <p className="alert-plain">На сайте возникла ошибка: <span style={ {fontSize: "16px", color: "var(--compilation-error)"} }>{props.error.toString()}</span></p>
    <p className="alert-plain">Можете разобраться с ней сами (вы же программист) или <a href="https://t.me/sort_me_chat" target="_blank" rel="noreferrer">обратиться к нам.</a></p>
  </div>;
}

class TaskAlert extends React.Component {
  static contextType = GlobalContext;
  
  constructor(props) {
    super(props);

    // Leaves the history entry pushed on open (componentDidUpdate then closes the alert), or just closes it
    this.CloseAlert = () => {
      if (this.pushed_key && this.props.history.location.key === this.pushed_key) {
        this.props.history.goBack();
      } else {
        this.close();
      }
    }

    this.onKeyDown = event => {
      if (event.key === "Escape") {
        this.CloseAlert();
      } else if (event.key === "Tab") {
        this.trapFocus(event);
      }
    };

    this.state = {
      submission_data: undefined,
      id: undefined,
      display: "none",
      shown_test: null,
      viewedByAdmin: false,
    };

    this.container_ref = React.createRef();
    this.dialog_ref = React.createRef();
    this.backdrop_pressed = false;

    this.socket = null;
    this.pending_data = null;
  }

  close() {
    this.pushed_key = null;
    this.setState({
      submission_data: undefined,
      id: undefined,
      display: "none",
    });
  }

  /*
    The alert is a modal overlay with its own scroll: lock the page under it, keep focus inside and listen for Esc
    while it's open, give focus back to the opener afterwards. It also gets a history entry, so Back (button or
    swipe; the phone sheet looks like a page) closes it instead of leaving the task and the code typed there.
  */
  setOpen(open) {
    document.documentElement.classList.toggle("scroll-locked", open);
    if (open) {
      this.opener = document.activeElement;
      document.addEventListener("keydown", this.onKeyDown);
      this.dialog_ref.current?.focus({ preventScroll: true, });
      this.props.history.push({
        ...this.props.location,
        hash: this.state.isAdminList ? "#attempts" : "#attempt-" + this.state.id,
      });
      this.pushed_key = this.props.history.location.key;
    } else {
      document.removeEventListener("keydown", this.onKeyDown);
      this.opener?.focus({ preventScroll: true, });
      this.opener = null;
    }
  }

  trapFocus(event) {
    const dialog = this.dialog_ref.current;
    const focusable = dialog ? [...dialog.querySelectorAll("button:not(:disabled), a[href], textarea, [tabindex='0']")] : [];
    if (focusable.length === 0) {
      return;
    }

    const first = focusable[0], last = focusable[focusable.length - 1], active = document.activeElement;
    if (!dialog.contains(active) || (event.shiftKey ? active === first || active === dialog : active === last)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    }
  }

  componentDidUpdate(prev_props, prev_state) {
    const open = this.state.display === "block";
    if (open !== (prev_state.display === "block")) {
      this.setOpen(open);
    } else if (open && prev_props.location !== this.props.location && this.props.location.key !== this.pushed_key) {
      this.close(); // Back while open
    }
  }

  componentWillUnmount() {
    if (this.state.display === "block") {
      this.setOpen(false);
    }
  }

  // Switching between views inside the open alert starts at its top
  scrollToTop() {
    if (this.container_ref.current) {
      this.container_ref.current.scrollTop = 0;
    }
  }

  updateFromSocket(data, id) {
    if (this.state.id === id && this.state.display === "block") {
      let new_state = data;
      if (this.state.submission_data) {
        new_state["code"] = this.state.submission_data.code;
        new_state["submitted_at"] = this.state.submission_data.submitted_at;
        new_state["lang"] = this.state.submission_data.lang;
        new_state["user_id"] = this.state.submission_data.user_id;
        new_state["id"] = this.state.submission_data.id;
        this.setState({ submission_data: new_state, });
      } else {
        this.pending_data = new_state;
      }
    }
  }

  updateShownTest(test_number, id) {
    if (this.state.id === id && this.state.display === "block") {
      this.setState({ shown_test: test_number, });
    }
  }

  updateContent(id, viewedByAdmin = false) {
    this.setState({
      display: "block",
      id: id,
      viewedByAdmin: viewedByAdmin,
      isAdminList: false,
      submission_data: null,
    }, () => this.scrollToTop());

    let response = _fetchApi(`/getSubmissionInfo?id=${id}`, {
      method: "GET",
      headers: {"Authorization": "Bearer " + this.context.token,},
    }).then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    }).then(response => response.json()).catch(error => this.setState({submission_data: {error: error,},}));
    response.then(result => {
      if (this.state.display === "block" && result?.id == this.state.id) {
        if (this.pending_data) {
          this.setState({
            submission_data: {...this.pending_data, ...result},
          }, () => this.pending_data = null);
        } else {
          this.setState({
            submission_data: result,
          });
        }
      }
    });
  }

  showMore() {
    if (this.state.buttonText === "Показать ещё") {
      this.setState({ buttonText: <LoaderSmall height={22} width={22} /> });
      const apiResponse = _fetchApi(`/getSubmissions?user_id=${this.state.userId}&task_id=${this.state.taskId}&contest_id=${this.props.params.contest_id}&offset=${this.state.submission_data.submissions[this.state.submission_data.submissions.length - 1].id}`, {
        method: "GET",
        headers: {"Authorization": "Bearer " + this.context.token,},
      }).then(response => response.json());
      apiResponse.then(result => {
        this.setState({
          submission_data: {
            ...this.state.submission_data,
            submissions: this.state.submission_data.submissions.concat(result.submissions),
          },
          buttonText: "Показать ещё",
        });
      });
    }
  }

  setAdminView(userId = this.state.userId, taskId = this.state.taskId, userName = this.state.userName, taskName = this.state.taskName) {
    this.setState({
      display: "block",
      submission_data: null,
      isAdminList: true,
      userId: userId,
      taskId: taskId,
      userName: userName,
      taskName: taskName,
    }, () => this.scrollToTop());

    const apiResponse = _fetchApi(`/getSubmissions?user_id=${userId}&task_id=${taskId}&contest_id=${this.props.params.contest_id}`, {
      method: "GET",
      headers: {"Authorization": "Bearer " + this.context.token,},
    }).then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    }).then(response => response.json()).catch(error => this.setState({ submission_data: { error: error, }, }));
    apiResponse.then(result => {
      result && this.setState({ // undefined when the request failed (the error is already shown)
        submission_data: {
          ...result,
        },
        buttonText: "Показать ещё",
      })
    });
  }

  /*
    Overlay (#task-alert-container) that scrolls on its own, with the card (.task-alert) inside:
    a centered card on tablet/desktop, a full-screen sheet with a sticky close button on phones.
  */
  render() {
    if (this.state.display !== "block") {
      return null;
    }

    const has_error = this.state.submission_data?.hasOwnProperty("error");
    return <div
      id="task-alert-container"
      ref={this.container_ref}
      onMouseDown={event => this.backdrop_pressed = event.target === event.currentTarget}
      onClick={event => this.backdrop_pressed && event.target === event.currentTarget && this.CloseAlert()}
    >
      <div
        className={clsx("task-alert", this.state.isAdminList && !has_error && "task-alert-admin")}
        role="dialog"
        aria-modal="true"
        aria-labelledby="task-alert-title"
        tabIndex={-1}
        ref={this.dialog_ref}
      >
        <div className="task-alert-topbar">
          <Button className="task-alert-close" aria-label="Закрыть" disableElevation disableRipple onClick={this.CloseAlert}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.833 9.99209L19.4146 3.4105C20.1951 2.63067 20.1951 1.36537 19.4146 0.584871C18.6341 -0.194957 17.3702 -0.194957 16.5897 0.584871L10.0081 7.16646L3.42648 0.585537C2.64666 -0.194957 1.38135 -0.194957 0.600854 0.585537C-0.178974 1.36537 -0.178974 2.63067 0.600854 3.41117L7.18245 9.99209L0.584871 16.5897C-0.194957 17.3695 -0.194957 18.6348 0.584871 19.4146C0.974453 19.8049 1.48657 20 1.99735 20C2.50814 20 3.02025 19.8049 3.4105 19.4146L10.0074 12.8177L16.5883 19.3986C16.9786 19.7889 17.49 19.984 18.0008 19.984C18.5116 19.984 19.0231 19.7889 19.4133 19.3986C20.1938 18.6188 20.1938 17.3535 19.4133 16.5737L12.833 9.99209Z" fill="#D4D4D4" style={ {transition: "fill 0.2s linear",} } />
            </svg>
          </Button>
        </div>
        {has_error ? <>
          <h2 id="task-alert-title">Попытка №{this.state.id}</h2>
          <DeniedInfo error={this.state.submission_data.error} />
        </> : this.state.submission_data ? (() => {
            if (this.state.isAdminList) {
              return <>
                <div className="title">
                  <UserAvatar user_id={this.state.userId} size={30} />
                  <h3 id="task-alert-title">
                    Попытки {this.state.userName} по задаче "{this.state.taskName}"
                  </h3>
                </div>
                <Separator />
                <div className="admin-submission-scroll">
                <table cellSpacing="0" className="admin-submission-list">
                  <thead>
                    <tr>
                      <th>Баллы</th>
                      <th>Вердикт</th>
                      <th>Тест</th>
                      <th>Когда</th>
                      <th>Язык</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.submission_data.submissions.map((element, index) => {
                      const bar = <svg width="6" height="20" viewBox="0 0 2 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0V20" stroke="var(--subtask-stroke)" /></svg>;

                      let color;
                      if (element.hasOwnProperty("total_points")) {
                        switch (element.total_points) {
                          case (100):
                            color = "submisson-green";
                            break;
                          case (0):
                            color = "submisson-red";
                            break;
                          default:
                            color = "submisson-black";
                        }
                      } else {
                        if (element.shown_verdict === 0) {
                          color = "submisson-black";
                        } else {
                          color = "submisson-red";
                        }
                      }

                      return <tr
                        className={"subtask-item " + color}
                        key={index}
                        id={"submission-" + element.id}
                        {...clickableRow(() => this.updateContent(element.id, true))}
                        style={{ cursor: "pointer", }}
                      >
                        <td><p>{element.shown_verdict !== 5 && element?.total_points}</p></td>
                        <td><div className="subtask-item-container">{bar}<p>{element.shown_verdict_text}</p></div></td>
                        <td><div className="subtask-item-container">{bar}<p>{element.hasOwnProperty("shown_test") ? (element.shown_test == 0 ? "" : element.shown_test) : ""}</p></div></td>
                        <td><div className="subtask-item-container secondary">{bar}<span>{adminSubmissionDateConverter(element.submitted_at)}</span></div></td>
                        <td><div className="subtask-item-container secondary">{bar}<span>{this.props.available_verbose[this.props.available_api.indexOf(element.lang)]}</span></div></td>
                      </tr>;
                    })}
                  </tbody>
                </table>
                </div>
                {this.state.submission_data.count > this.state.submission_data.submissions.length && <div style={{ display: "flex", justifyContent: "center", }}>
                  <Button
                    disableElevation
                    disableRipple
                    className="task-show-more"
                    onClick={() => this.showMore()}
                  >{this.state.buttonText}</Button>
                </div>}
              </>;
            } else {
              return <>
                {this.state.viewedByAdmin && <button className="admin-back-button" onClick={() => this.setAdminView()}>← К попыткам по задаче</button>}
                <h2 id="task-alert-title">Попытка №{this.state.id}</h2>
                <div className="task-alert-meta">
                  <span>{this.props.available_verbose[this.props.available_api.indexOf(this.state.submission_data.lang)] ?? "zip архив"}</span>
                  <svg width="5" height="5" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="2" cy="2" r="1.5" fill="var(--difficulty)" />
                  </svg>
                  <span>{dateConverter(this.state.submission_data.submitted_at)}</span>
                </div>
                {this.state.submission_data.lang === "zip" ? (
                  <SubmittedArchiveViewer descriptionString={this.state.submission_data.code} />
                ) : (
                  <GlobalContext.Consumer>
                    {() => <AceEditor
                      width="100%"
                      mode={this.props.available_highlight[this.props.available_api.indexOf(this.state.submission_data.lang)] || "text"}
                      theme={this.context.theme === "light" ? "chrome" : "dracula"}
                      className="code-editor submission"
                      editorProps= { {$blockScrolling: true,} }
                      fontSize="16px"
                      highlightActiveLine={false}
                      readOnly={true}
                      setOptions={{
                        wrap: true,
                        showPrintMargin: false,
                        maxLines: 19,
                        useWorker: false,
                      }}
                      onLoad={ editor => {
                        editor.renderer.setPadding(12);
                        editor.renderer.setScrollMargin(12, 24);
                        editor.setValue(this.state.submission_data.code, 1);
                        editor.clearSelection();
                      } }
                    />}
                  </GlobalContext.Consumer>
                )}
                {!this.state.submission_data.compiled && this.state.submission_data.compiler_log === "" ? <>
                  <Separator />
                  <WebSocketLoader 
                    text={this.state.shown_test && `Решение проверяется: тест ${this.state.shown_test}...`}
                  />
                </> : <>
                  <div className="task-alert-block">
                    <p className="alert-category-header">Компиляция</p>
                    {
                      this.state.submission_data.compiler_log === "" ?
                        <div style={ {display: "flex", alignItems: "center",} }>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.8978 11.6317L11.9417 7.82061L9.74895 2.92283C9.47006 2.20227 9.82839 1.39172 10.5489 1.11338C11.2689 0.832273 12.0801 1.19283 12.3589 1.91338L15.8051 10.6739L12.8978 11.6317Z" fill="#EF9645"/>
                            <path d="M17.5359 10.2494C17.2648 8.81554 16.4315 6.62554 16.4315 6.62554L13.2165 0.798321C12.8687 0.108321 12.0265 -0.168345 11.337 0.178877C10.647 0.526654 10.3693 1.36832 10.7176 2.05832L13.6787 7.36221C13.6859 7.37443 14.4637 10.4128 14.4637 10.4128C13.8648 9.85999 13.0154 9.10221 12.2332 8.40277C10.512 6.86277 9.49094 6.28554 9.49094 6.28554C9.09649 6.03943 8.83594 6.00443 8.30649 6.25277L5.04427 7.67943C4.95705 7.72277 4.88316 7.78388 4.82482 7.86221L3.53982 9.57665C3.04371 10.1694 3.12205 11.0517 3.71482 11.5472C4.30705 12.0433 5.18871 11.9639 5.68594 11.3728C5.7126 11.3405 6.67482 9.95054 6.76149 9.9061C7.3376 9.60999 8.40871 9.10221 8.87705 9.11721C9.37538 9.13332 12.3665 12.4267 12.3665 12.4267C12.4809 12.5705 12.4943 12.77 12.3998 12.9278L10.7804 15.8322C10.7365 15.905 10.6732 15.9633 10.597 16.0005L9.11149 16.8339C9.02594 16.8755 8.92927 16.8889 8.83594 16.8711L5.90816 15.6089C5.7626 15.5461 5.64149 15.4311 5.57927 15.285C5.14205 14.2572 5.08038 13.2744 5.07982 13.2633C5.04371 12.4911 4.38871 11.895 3.61649 11.9311C2.84594 11.9622 2.24816 12.6217 2.28427 13.3939C2.29149 13.54 2.47927 16.5272 4.91038 18.5561C6.31482 19.7272 8.05149 20.1805 10.2709 19.8822C12.8332 19.5383 14.4204 19.1972 16.6632 14.5722C17.2837 13.2917 17.7204 11.2255 17.5359 10.2494Z" fill="#FFDC5D"/>
                          </svg>
                          <p className="alert-plain">Решение скомпилировалось без ошибок в отведенное время</p>
                        </div> :
                        <>
                          <p className="alert-plain">Решение не скомпилировалось. Вывод компилятора:</p>
                          <AceEditor
                            width="100%"
                            mode="text"
                            theme={this.context.theme === "light" ? "chrome" : "dracula"}
                            className="code-editor compiler-log"
                            editorProps= { {$blockScrolling: true,} }
                            fontSize="16px"
                            highlightActiveLine={false}
                            readOnly={true}
                            setOptions={ {
                              wrap: false, // keeps the columns: the ^ markers point under the right characters
                              showPrintMargin: false,
                              maxLines: 19,
                            } }
                            showGutter={false}
                            onLoad={ editor => {
                              editor.renderer.setPadding(16, 24, 16, 16);
                              editor.renderer.setScrollMargin(16, 24);
                              editor.setValue(this.state.submission_data.compiler_log, 1);
                              editor.clearSelection();
                            } }
                          />
                        </>
                    }
                    <Separator />
                    {(() => {
                      if (this.state.submission_data.subtasks) {
                        return this.state.submission_data.subtasks.map((element, index) => {
                          return <div key={index}>
                            <div className="task-alert-block">
                              {(() => {
                                if (this.props.task_data?.subtasks?.[index].num === 0) {
                                  return <p className="alert-category-header">Тесты из условия</p>;
                                } else {
                                  return <p className="alert-category-header">Подзадача {this.props.task_data.hasOwnProperty("subtasks") ? this.props.task_data.subtasks[index].num : index + 1}</p>;
                                }
                              })()}
                              {element.skipped ?
                                <p className="alert-plain">Не тестировалась, так как не выполена подзадача {element.skip_reason}</p>
                                : <>{(() => {
                                  if (element.failed_tests === null) {
                                    if (this.props.task_data?.subtasks?.[index].num === 0) {
                                      return <div style={ {display: "flex", alignItems: "center",} }>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M12.8978 11.6317L11.9417 7.82061L9.74895 2.92283C9.47006 2.20227 9.82839 1.39172 10.5489 1.11338C11.2689 0.832273 12.0801 1.19283 12.3589 1.91338L15.8051 10.6739L12.8978 11.6317Z" fill="#EF9645"/>
                                          <path d="M17.5359 10.2494C17.2648 8.81554 16.4315 6.62554 16.4315 6.62554L13.2165 0.798321C12.8687 0.108321 12.0265 -0.168345 11.337 0.178877C10.647 0.526654 10.3693 1.36832 10.7176 2.05832L13.6787 7.36221C13.6859 7.37443 14.4637 10.4128 14.4637 10.4128C13.8648 9.85999 13.0154 9.10221 12.2332 8.40277C10.512 6.86277 9.49094 6.28554 9.49094 6.28554C9.09649 6.03943 8.83594 6.00443 8.30649 6.25277L5.04427 7.67943C4.95705 7.72277 4.88316 7.78388 4.82482 7.86221L3.53982 9.57665C3.04371 10.1694 3.12205 11.0517 3.71482 11.5472C4.30705 12.0433 5.18871 11.9639 5.68594 11.3728C5.7126 11.3405 6.67482 9.95054 6.76149 9.9061C7.3376 9.60999 8.40871 9.10221 8.87705 9.11721C9.37538 9.13332 12.3665 12.4267 12.3665 12.4267C12.4809 12.5705 12.4943 12.77 12.3998 12.9278L10.7804 15.8322C10.7365 15.905 10.6732 15.9633 10.597 16.0005L9.11149 16.8339C9.02594 16.8755 8.92927 16.8889 8.83594 16.8711L5.90816 15.6089C5.7626 15.5461 5.64149 15.4311 5.57927 15.285C5.14205 14.2572 5.08038 13.2744 5.07982 13.2633C5.04371 12.4911 4.38871 11.895 3.61649 11.9311C2.84594 11.9622 2.24816 12.6217 2.28427 13.3939C2.29149 13.54 2.47927 16.5272 4.91038 18.5561C6.31482 19.7272 8.05149 20.1805 10.2709 19.8822C12.8332 19.5383 14.4204 19.1972 16.6632 14.5722C17.2837 13.2917 17.7204 11.2255 17.5359 10.2494Z" fill="#FFDC5D"/>
                                        </svg>
                                        <p className="alert-plain">Пройдены</p>
                                      </div>;
                                    } else {
                                      return <><div style={{ display: "flex", alignItems: "center", }}>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g>
                                            <path d="M6.45885 4.15992C6.39663 4.22214 6.3494 4.29714 6.30996 4.37936L6.30552 4.37492L0.0744045 18.4116L0.0805156 18.4177C-0.03504 18.6416 0.158293 19.0971 0.554404 19.4938C0.950516 19.8899 1.40607 20.0833 1.62996 19.9677L1.63552 19.9733L15.6722 13.7416L15.6677 13.7366C15.7494 13.6977 15.8244 13.6505 15.8872 13.5871C16.755 12.7194 15.3477 9.90548 12.745 7.30214C10.1411 4.69881 7.32718 3.29214 6.45885 4.15992Z" fill="#DD2E44"/>
                                            <path d="M7.22218 6.66675L0.231071 18.059L0.0744045 18.4117L0.0805156 18.4179C-0.03504 18.6417 0.158293 19.0973 0.554404 19.494C0.683293 19.6229 0.817182 19.7206 0.948293 19.8034L9.44441 9.44453L7.22218 6.66675Z" fill="#EA596E"/>
                                            <path d="M12.7846 7.25891C15.3791 9.85447 16.8196 12.6211 16.0008 13.4389C15.1824 14.2578 12.4158 12.8178 9.81964 10.2234C7.22464 7.6278 5.78464 4.86003 6.60298 4.04169C7.42186 3.22336 10.1885 4.66336 12.7846 7.25891Z" fill="#A0041E"/>
                                            <path d="M10.3279 7.56053C10.2173 7.64997 10.0729 7.69664 9.92007 7.67997C9.43785 7.62775 9.03229 7.45997 8.74841 7.19497C8.44785 6.91442 8.29952 6.53775 8.34007 6.16053C8.41118 5.49831 9.07563 4.89053 10.2084 5.01275C10.649 5.05997 10.8456 4.91831 10.8523 4.85053C10.8601 4.78331 10.6984 4.60275 10.2579 4.55497C9.77563 4.50275 9.37007 4.33497 9.08563 4.06997C8.78507 3.78942 8.63618 3.41275 8.6773 3.03553C8.74952 2.37331 9.41341 1.76553 10.5451 1.88831C10.8662 1.92275 11.0356 1.85664 11.1073 1.81386C11.1645 1.77886 11.1873 1.74553 11.1895 1.72609C11.1962 1.65886 11.0367 1.47831 10.5951 1.43053C10.2901 1.3972 10.069 1.12386 10.1029 0.818308C10.1356 0.513308 10.4084 0.292752 10.7145 0.326086C11.8462 0.447752 12.3662 1.18275 12.2945 1.84553C12.2223 2.50886 11.5584 3.11553 10.4256 2.99386C10.1045 2.95886 9.93674 3.02553 9.86452 3.06831C9.8073 3.10275 9.78396 3.13664 9.78174 3.15553C9.77452 3.22331 9.93507 3.40331 10.3767 3.45109C11.5084 3.57331 12.0284 4.30775 11.9567 4.97053C11.8851 5.63275 11.2212 6.24053 10.089 6.11775C9.76785 6.08331 9.59896 6.14997 9.52674 6.1922C9.46896 6.22775 9.44674 6.26109 9.44452 6.27997C9.43729 6.3472 9.59785 6.52775 10.039 6.57553C10.3434 6.60886 10.5651 6.88275 10.5312 7.18775C10.5156 7.33997 10.4384 7.47164 10.3279 7.56053Z" fill="#AA8DD8"/>
                                            <path d="M17.0338 12.6983C18.1299 12.3889 18.886 12.8778 19.066 13.5195C19.246 14.1606 18.856 14.9722 17.7604 15.2806C17.3326 15.4006 17.2043 15.605 17.2215 15.67C17.2404 15.7356 17.4576 15.8433 17.8843 15.7228C18.9799 15.4145 19.736 15.9033 19.916 16.5445C20.0971 17.1861 19.706 17.9967 18.6099 18.3056C18.1826 18.4256 18.0538 18.6306 18.0726 18.6956C18.091 18.7606 18.3076 18.8683 18.7349 18.7483C19.0293 18.6656 19.3371 18.8372 19.4199 19.1322C19.5021 19.4278 19.3304 19.7345 19.0349 19.8178C17.9399 20.1261 17.1832 19.6383 17.0021 18.9961C16.8221 18.355 17.2126 17.5445 18.3093 17.2356C18.7371 17.115 18.8654 16.9111 18.8465 16.8456C18.8288 16.7806 18.6121 16.6722 18.1854 16.7922C17.0888 17.1011 16.3332 16.6133 16.1526 15.9706C15.9721 15.3295 16.3626 14.5189 17.4588 14.2095C17.8854 14.09 18.0138 13.8845 17.996 13.82C17.9771 13.7545 17.761 13.6467 17.3338 13.7667C17.0382 13.85 16.7321 13.6778 16.6488 13.3828C16.566 13.0883 16.7382 12.7817 17.0338 12.6983Z" fill="#77B255"/>
                                            <path d="M12.7782 11.2001C12.6149 11.2001 12.4537 11.1284 12.3437 10.9918C12.1521 10.7518 12.1915 10.4023 12.4304 10.2107C12.5515 10.1134 15.4404 7.84454 19.5232 8.42843C19.8271 8.47176 20.0382 8.75287 19.9949 9.05676C19.9515 9.3601 19.6726 9.57343 19.366 9.52787C15.7587 9.01565 13.151 11.0579 13.1254 11.0784C13.0221 11.1607 12.8999 11.2001 12.7782 11.2001Z" fill="#AA8DD8"/>
                                            <path d="M3.1966 8.88894C3.14382 8.88894 3.08993 8.88116 3.0366 8.86561C2.74271 8.77727 2.57604 8.46783 2.66437 8.17394C3.29382 6.07783 3.86437 2.73283 3.16326 1.86061C3.08493 1.76172 2.9666 1.66449 2.69549 1.68505C2.17437 1.72505 2.22382 2.82449 2.22437 2.83561C2.24771 3.14172 2.01771 3.40838 1.71215 3.43116C1.4016 3.45005 1.13937 3.22449 1.1166 2.91838C1.05937 2.15227 1.29771 0.676717 2.61215 0.577272C3.19882 0.532828 3.68604 0.736717 4.02993 1.16449C5.34715 2.80394 4.00993 7.55672 3.72882 8.49338C3.6566 8.73394 3.43549 8.88894 3.1966 8.88894Z" fill="#77B255"/>
                                            <path d="M14.1668 6.111C14.6271 6.111 15.0002 5.73791 15.0002 5.27767C15.0002 4.81743 14.6271 4.44434 14.1668 4.44434C13.7066 4.44434 13.3335 4.81743 13.3335 5.27767C13.3335 5.73791 13.7066 6.111 14.1668 6.111Z" fill="#5C913B"/>
                                            <path d="M1.11111 11.1111C1.72476 11.1111 2.22222 10.6137 2.22222 10C2.22222 9.38638 1.72476 8.88892 1.11111 8.88892C0.497461 8.88892 0 9.38638 0 10C0 10.6137 0.497461 11.1111 1.11111 11.1111Z" fill="#9266CC"/>
                                            <path d="M18.0555 11.6667C18.5157 11.6667 18.8888 11.2936 18.8888 10.8333C18.8888 10.3731 18.5157 10 18.0555 10C17.5953 10 17.2222 10.3731 17.2222 10.8333C17.2222 11.2936 17.5953 11.6667 18.0555 11.6667Z" fill="#5C913B"/>
                                            <path d="M13.0555 18.3334C13.5157 18.3334 13.8888 17.9603 13.8888 17.5001C13.8888 17.0398 13.5157 16.6667 13.0555 16.6667C12.5953 16.6667 12.2222 17.0398 12.2222 17.5001C12.2222 17.9603 12.5953 18.3334 13.0555 18.3334Z" fill="#5C913B"/>
                                            <path d="M15.5554 3.33331C16.1691 3.33331 16.6666 2.83584 16.6666 2.2222C16.6666 1.60855 16.1691 1.11108 15.5554 1.11108C14.9418 1.11108 14.4443 1.60855 14.4443 2.2222C14.4443 2.83584 14.9418 3.33331 15.5554 3.33331Z" fill="#FFCC4D"/>
                                            <path d="M18.0555 5.55558C18.5157 5.55558 18.8888 5.18249 18.8888 4.72225C18.8888 4.26201 18.5157 3.88892 18.0555 3.88892C17.5953 3.88892 17.2222 4.26201 17.2222 4.72225C17.2222 5.18249 17.5953 5.55558 18.0555 5.55558Z" fill="#FFCC4D"/>
                                            <path d="M16.389 7.77775C16.8492 7.77775 17.2223 7.40465 17.2223 6.94442C17.2223 6.48418 16.8492 6.11108 16.389 6.11108C15.9288 6.11108 15.5557 6.48418 15.5557 6.94442C15.5557 7.40465 15.9288 7.77775 16.389 7.77775Z" fill="#FFCC4D"/>
                                            <path d="M4.16683 13.8888C4.62707 13.8888 5.00016 13.5157 5.00016 13.0555C5.00016 12.5953 4.62707 12.2222 4.16683 12.2222C3.70659 12.2222 3.3335 12.5953 3.3335 13.0555C3.3335 13.5157 3.70659 13.8888 4.16683 13.8888Z" fill="#FFCC4D"/>
                                          </g>
                                        </svg>
                                        <p className="alert-plain"><span>{element.points}</span>/{(() => {
                                          if (this.props.task_data.hasOwnProperty("subtasks")) {
                                            return this.props.task_data.subtasks[index].points;
                                          } else if (this.props.contest_data) {
                                            for (const task of this.props.contest_data) {
                                              if (task.id === this.state?.taskId)
                                                return task.subtasks?.[index].points || 100;
                                            }
                                            return 100;
                                          }
                                          return 100;
                                        })()} баллов</p>
                                      </div>
                                      {this.state.submission_data.lang !== "zip" && <p className="worst-time">Худшее время: {element.worst_time / 1000} сек</p>}
                                    </>;
                                    }
                                  } else {
                                    let testInfo;
                                    if (this.props.task_data?.subtasks?.[index].num === 0) {
                                      testInfo = <p className="alert-plain">Не пройдены</p>;
                                    } else if (this.props.contest_data) {
                                      for (const task of this.props.contest_data) {
                                        if (task.id === this.state?.taskId) {
                                          testInfo = <p className="alert-plain"><span>{element.points}</span>/{task.subtasks?.[index].points || 100} баллов</p>;
                                          break;
                                        }
                                      }
                                    } else {
                                      testInfo = <p className="alert-plain"><span>{element.points}</span>/{(this.props.task_data.hasOwnProperty("subtasks") ? this.props.task_data.subtasks[index].points : 100)} баллов</p>;
                                    }
                                    return <>
                                      {testInfo}
                                      <table cellSpacing="0" className="failed-tests-table"><tbody>
                                        <tr className="subtask-header">
                                          <td>Тест</td>
                                          <td>Вердикт</td>
                                          <td>Время</td>
                                        </tr>
                                        {element.failed_tests.map((test, failed_index) => {
                                          const bar = <svg width="6" height="20" viewBox="0 0 2 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0V20" stroke="var(--subtask-stroke)" /></svg>;
                                          return <tr className="subtask-item submisson-red" key={failed_index}>
                                            <td><div className="subtask-item-container"><p>{test.n}</p></div></td>
                                            <td><div className="subtask-item-container">{bar}<p>{test.verdict_text}</p></div></td>
                                            <td><div className="subtask-item-container">{bar}<p>{
                                              this.state.submission_data.lang === "zip" ? ""
                                                : test.verdict === 3 ? "> " + Math.floor(test.milliseconds / 1000)
                                                : test.milliseconds / 1000
                                              }</p></div></td>
                                          </tr>;
                                        })}
                                      </tbody></table>
                                    </>;
                                  }
                                })()}</>}
                            </div>
                            <Separator />
                          </div>;
                        });
                      } else {
                        return <></>;
                      }
                    })()}
                    <div className="task-alert-block">
                      <p className="alert-category-header">Результат</p>
                      <p className="alert-plain"><span>{this.state.submission_data.total_points}</span>/100 баллов</p>
                    </div>
                  </div>
                </>}
              </>;
            }
          })() : this.state.isAdminList ? <>
            <div className="title">
              <UserAvatar user_id={this.state.userId} size={30} />
              <h3 id="task-alert-title">
                Попытки {this.state.userName} по задаче "{this.state.taskName}"
              </h3>
            </div>
            <Separator />
            <Loader />
          </> : <>
            {this.state.viewedByAdmin && <button className="admin-back-button" onClick={() => this.setAdminView()}>← К попыткам по задаче</button>}
            <h2 id="task-alert-title">Попытка №{this.state.id}</h2>
            <Loader />
          </>}
      </div>
    </div>;
  }
}

const TaskWrapper = (props) => {
  const [key, setKey] = useState(0);

  function refreshPage() {
    setKey(key + 1);
  }

  return <Task {...props} refreshPage={() => refreshPage()} params={useParams()} key={key} />;
}

class ContestTask extends Task {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.submitted_ref = React.createRef();
    this.alert_ref = React.createRef();
    this.sidebar_ref = React.createRef();
    this.content_ref = React.createRef();
    this.jury_connection_ref = React.createRef();
    this.layout_ref = React.createRef();

    this.sockets = {};
    this.jury_socket = null;
    this.timeouts = [];

    this.state = {
      contest_data: undefined,
      current_task_data: undefined,
      status: undefined,
      name: undefined,
      server_time: undefined,
      destination_time: undefined,
      available_verbose: ["Загрузка..."],
      available_api: [],
      available_highlight: [],
      extensions: [],
    };
  }

  initJuryWebsocket() {
    this.jury_socket = new WebSocket(`wss://api.sort-me.org/ws/contestCommunication?id=${this.props.params.contest_id}&token=${this.context.token}`);

    const new_timeout = setTimeout(() => {
      if (this.jury_socket.readyState === WebSocket.CLOSED) {
        this.initJuryWebsocket();
      }
    }, 5000);
    this.timeouts.push(new_timeout);

    this.jury_connection_ref.current.jury_socket = this.jury_socket;
    if (this.jury_socket) {
      this.jury_socket.onclose = event => {
        if (event.code === 1006 && this.state.status !== "ended") {
          const new_timeout = setTimeout(() => {
            if (this.jury_socket.readyState === WebSocket.CLOSED) {
              this.initJuryWebsocket();
            }
          }, Math.floor(Math.random() * 4000 + 1000));
          this.timeouts.push(new_timeout);
        }
      };
      this.jury_socket.onerror = event => {
        console.log(event);
      };
      this.jury_socket.onmessage = event => {
        const message = JSON.parse(event.data);
        this.sidebar_ref.current.updateUnreads(message);
        if (Array.isArray(message)) { // Recieved array on socket open
          this.jury_connection_ref.current.initJuryChat(message);
        } else { // Normal message
          this.jury_connection_ref.current.handleNewMessage(message);
        }
      };
    }
  }

  getTaskContent() {
    const loadHighlighters = async langs => {
      for (const lang of langs.highlight) {
        await import(`ace-builds/src-min-noconflict/mode-${lang}`);
      }

      this.setState({
        available_verbose: langs.verbose,
        available_api: langs.api,
        available_highlight: langs.highlight,
        extensions: langs.extensions,
      });
    }

    let response = _fetchApi("/getContestTasks?id=" + this.props.params.contest_id, this.context.token ? {
      method: "GET",
      headers: { "Authorization": "Bearer " + this.context.token },
    } : { method: "GET" }).then(response => response.json());
    response.then(result => {
      if (result.hasOwnProperty("error")) {
        this.setState({
          contest_data: "bad_data",
          current_task_data: "bad_contest_data",
        }, () => document.title = "Контест не найден" + titleEnding);
      } else {
        const currentActive = this.props.params.id;
        let task;
        if (isNaN(currentActive)) {
          task = result.tasks ? currentActive : "waiting";
        } else {
          if (result.tasks) {
            if (parseInt(currentActive) === 0) {
              task = result.tasks[0] || "bad_data";
            } else {
              task = result.tasks.filter(element => element.id === parseInt(currentActive))[0] || "bad_data";
            }
          } else {
            task = "waiting";
          }
        }
        this.setState({
          contest_data: result.tasks || null,
          current_task_data: task,
          status: result.status,
          name: result.name,
          server_time: result.server_time * 1000,
          destination_time: result.ends * 1000 || result.starts * 1000,
          broadcast: result.broadcast,
          messaging_enabled: result.messaging_enabled,
          is_admin: result.is_admin,
        }, () => {
          document.title = result.name + titleEnding;

          this.sidebar_ref.current.updateUnreads(this.state.broadcast);
          this.jury_connection_ref.current.initAnnouncements(this.state.broadcast);
        });

        if (this.state.status !== "ended" && this.state.status !== "preparing") {
          this.initJuryWebsocket();
        }

        if (result.langs) {
          loadHighlighters(result.langs);
        }
      }
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();

    this.jury_socket?.close(1000);
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }

  updateTaskDataOnly(id) {
    this.submitted_ref.current.setState({ submitted: undefined });
    if (isNaN(id)) {
      this.setState({ current_task_data: id });
    } else {
      this.setState({ current_task_data: this.state.contest_data.filter(element => element.id === id)[0] });
    }

    // A new section starts at its top: when the page is scrolled past the layout, bring the layout back
    // (scroll-margin-top keeps it clear of the sticky top bar)
    const layout = this.layout_ref.current;
    if (layout && layout.getBoundingClientRect().top < 0) {
      layout.scrollIntoView();
    }
  }

  componentDidUpdate(prevProps) {
    // Browser back/forward (and the iOS edge swipe) only change the URL: make the page follow it.
    // Sidebar clicks update the state before the URL changes, so they stop at the equality check.
    if (prevProps.location.pathname === this.props.location.pathname || !Array.isArray(this.state.contest_data)) {
      return;
    }
    const last = this.props.params.id;
    let id = isNaN(last) ? last : parseInt(last);
    if (id === 0) {
      id = this.state.contest_data[0]?.id;
    }
    const current = this.state.current_task_data;
    const known = isNaN(id) || this.state.contest_data.some(element => element.id === id);
    if (id === undefined || !known || (current?.id ?? current) === id) {
      return;
    }
    this.sidebar_ref.current?.select(id);
    this.updateTaskDataOnly(id);
  }

  updateContestData(data) {
    this.setState({ contest_data: data });
  }

  showSubmissionList(userId, taskId, userName, taskName) {
    this.alert_ref.current.setAdminView(userId, taskId, userName, taskName)
  }

  updateSubmitted(id) {
    /* 
      Contest only method.
      Automatically establishes new websocket instead of making a request to a /getMySubmissionsByTaskId
    */
    this.establishWebsocket(id);
    this.submitted_ref.current.appendSubmission(id, this.state.current_task_data.id);
  }

  hadnleTimerExpire() {
    if (this.state.status === "running") {
      this.setState({ status: "ended", destination_time: null });
    } else {
      this.props.refreshPage();
    }
  }

  render() {
    return <div className="task-layout contest-layout" ref={this.layout_ref}>
      <aside className="task-sidebar contest-task-sidebar">
        <div className="task-sidebar-sticky">
          <ConetstTaskSidebar {...this.props}
            contest_data={this.state.contest_data}
            updateTaskData={id => this.updateTaskDataOnly(id)}
            destination_time={this.state.destination_time}
            server_time={this.state.server_time}
            status={this.state.status}
            name={this.state.name}
            messaging_enabled={this.state.messaging_enabled}
            isAdmin={this.state.is_admin}
            onTimerExpire={() => this.hadnleTimerExpire()}
            ref={this.sidebar_ref}
          />
        </div>
      </aside>
      <ContestJuryConnection {...this.props}
        messaging_enabled={this.state.messaging_enabled}
        type={this.state.current_task_data}
        ref={this.jury_connection_ref}
        status={this.state.status}
      />
      <div className="task-container">
        <TaskContent {...this.props}
          contestTasksData={this.state.contest_data}
          contestId={this.props.params.contest_id}
          task_data={this.state.current_task_data}
          updateSubmitted={id => this.updateSubmitted(id)}
          updateContestData={data => this.updateContestData(data)}
          showSubmissionList={(taskId, userId, userName, taskName) => this.showSubmissionList(taskId, userId, userName, taskName)}
          available_verbose={this.state.available_verbose}
          available_api={this.state.available_api}
          available_highlight={this.state.available_highlight}
          extensions={this.state.extensions}
          messaging_enabled={this.state.messaging_enabled}
          isAdmin={this.state.is_admin}
          onTimerExpire={() => this.refreshPage()}
          timer_now={this.state.server_time}
          timer_countdown_until={this.state.destination_time}
          ref={this.content_ref}
        />
        <TaskSubmitted {...this.props}
          task_data={this.state.current_task_data}
          showSubmission={id => this.showSubmission(id)}
          establishWebsocket={id => this.establishWebsocket(id)}
          ref={this.submitted_ref}
        />
      </div>
      <TaskAlert {...this.props}
        task_data={this.state.current_task_data}
        contest_data={this.state.contest_data}
        available_verbose={this.state.available_verbose}
        available_api={this.state.available_api}
        available_highlight={this.state.available_highlight}
        ref={this.alert_ref}
      />
    </div>;
  }
}

const CONTEST_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

// Per-contest counters of already seen announcements / chat messages (they drive the unread badges)
function readMessageCounts(contestId) {
  let counts = null;
  try {
    counts = JSON.parse(window.localStorage.getItem("contest_messages_count"));
  } catch (e) {}
  counts = counts || {};
  counts[contestId] = counts[contestId] || { announcements: 0, chat: 0, };
  return counts;
}

function writeMessageCounts(counts) {
  try {
    window.localStorage.setItem("contest_messages_count", JSON.stringify(counts));
  } catch (e) {}
}

function ContestSidebarSeparator() {
  return <div className="contest-sidebar-separator" aria-hidden="true" />;
}

/*
  One component for every width: a sidebar column on tablet/desktop, a sticky contest bar on phones
  (title + timer row, then a horizontally scrolling row of chips). ContestTask talks to it through a ref.
*/
class ConetstTaskSidebar extends React.Component {
  constructor(props) {
    super(props);

    let currentActive = this.props.params.id;
    currentActive = isNaN(currentActive) ? currentActive : parseInt(currentActive);

    writeMessageCounts(readMessageCounts(this.props.params.contest_id));

    this.state = {
      active: currentActive,
      announcements_unreads: 0,
      chat_unreads: 0,
    };

    this.nav_ref = React.createRef();
    this.notification = new Audio(notification_sound);
  }

  updateUnreads(message) {
    if (message) {
      const contest_id = this.props.params.contest_id;
      const counts = readMessageCounts(contest_id);

      let new_announcements_unreads = this.state.announcements_unreads;
      let new_chat_unreads = this.state.chat_unreads;
      if (Array.isArray(message) && message.length > 0) {
        if (message[0].hasOwnProperty("from_jury")) {
          new_chat_unreads = message.length - counts[contest_id].chat;
        } else {
          new_announcements_unreads = message.length - counts[contest_id].announcements;
        }
      } else if (!Array.isArray(message)) {
        if (message.is_broadcast) {
          new_announcements_unreads += 1;
        } else {
          new_chat_unreads += 1;
        }
      }

      if (this.state.active === "announcements") {
        counts[contest_id].announcements += new_announcements_unreads;
      } else if (this.state.active === "messages") {
        counts[contest_id].chat += new_chat_unreads;
      }
      writeMessageCounts(counts);

      if (!((this.state.announcements_unreads === new_announcements_unreads && this.state.chat_unreads === new_chat_unreads) || (new_announcements_unreads === 0 && new_chat_unreads === 0) || (new_announcements_unreads !== 0 && this.state.active === "announcements" && !document.hidden) || (new_chat_unreads !== 0 && this.state.active === "messages" && !document.hidden))) {
        // Browsers reject sounds before the first user gesture; the badge is enough then
        this.notification.play()?.catch(() => {});
      }

      this.setState({
        announcements_unreads: this.state.active === "announcements" ? 0 : new_announcements_unreads,
        chat_unreads: this.state.active === "messages" ? 0 : new_chat_unreads,
      });
    }
  }

  // Marks a section as active; opening announcements / chat marks their messages as read
  select(id) {
    if (id === this.state.active) {
      return;
    }
    const contest_id = this.props.params.contest_id;
    if (id === "announcements" || id === "messages") {
      const counts = readMessageCounts(contest_id);
      if (id === "announcements") {
        counts[contest_id].announcements += this.state.announcements_unreads;
        this.setState({ active: id, announcements_unreads: 0, });
      } else {
        counts[contest_id].chat += this.state.chat_unreads;
        this.setState({ active: id, chat_unreads: 0, });
      }
      writeMessageCounts(counts);
    } else {
      this.setState({ active: id, });
    }
  }

  // Phones: keep the active chip in view inside the horizontally scrolling row (no-op when it doesn't scroll
  // or the chip is already fully visible)
  revealActive() {
    const nav = this.nav_ref.current;
    const chip = nav?.querySelector("[aria-current]");
    if (!chip || nav.scrollWidth <= nav.clientWidth) {
      return;
    }
    const navRect = nav.getBoundingClientRect();
    const chipRect = chip.getBoundingClientRect();
    if (chipRect.left >= navRect.left && chipRect.right <= navRect.right) {
      return;
    }
    nav.scrollLeft += chipRect.left + chipRect.width / 2 - (navRect.left + navRect.width / 2);
  }

  componentDidMount() {
    // Web fonts change the chip widths after the first layout
    document.fonts?.ready.then(() => this.revealActive());
  }

  componentDidUpdate(prevProps, prevState) {
    if (Array.isArray(this.props.contest_data) && this.props.contest_data.length > 0 && this.state.active === 0) {
      this.setState({active: this.props.contest_data[0].id});
    }
    // chips change width when data or unread badges arrive
    if (prevState !== this.state || prevProps.contest_data !== this.props.contest_data) {
      this.revealActive();
    }
  }

  renderItem({ id, content, label, unread, className }) {
    const badge = unread > 0 && <span className="contest-sidebar-unread">{unread}</span>;

    if (this.state.active === id) {
      return <span key={id} className={clsx("contest-sidebar-link", "active", className)} aria-current="page" aria-label={label}>
        {content}{badge}
      </span>;
    }
    return <Link
      key={id}
      className={clsx("contest-sidebar-link", className)}
      to={`/contest/${this.props.params.contest_id}/${id}`}
      aria-label={label}
      onClick={() => {
        this.props.updateTaskData(id);
        this.select(id);
      }}
    >{content}{badge}</Link>;
  }

  render() {
    const contest_data = this.props.contest_data;

    if (contest_data === undefined) {
      return <></>;
    } else if (contest_data === "bad_data") {
      return <div className="task-list-scroll-wrapper contest-sidebar">
        <div className="contest-sidebar-head">
          <Link className="contest-sidebar-back" to={"/contest"}>← К соревнованиям</Link>
        </div>
      </div>;
    } else if (contest_data === null) {
      return <div className="task-list-scroll-wrapper contest-sidebar">
        <div className="contest-sidebar-head">
          <p className="contest-task-title">{this.props.name}</p>
        </div>
      </div>;
    }

    const sections = [
      { id: "rating", title: this.props.isAdmin ? "Участники" : "Рейтинг", },
      { id: "announcements", title: "Объявления", unread: this.state.announcements_unreads, },
      this.props.messaging_enabled && this.props.status !== "ended" && { id: "messages", title: "Чат с Жюри", unread: this.state.chat_unreads, },
      this.props.isAdmin && { id: "admin", title: "Админка", },
    ].filter(Boolean);

    return <div className="task-list-scroll-wrapper contest-sidebar">
        <div className="contest-sidebar-head">
          <p className="contest-task-title" title={this.props.name}>{this.props.name}</p>
          <div className={clsx("contest-task-timer", this.props.status === "ended" && "contest-ended")}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M12 2C13.5977 2 14.9037 3.24892 14.9949 4.82373L15 5V7C15 7.27541 14.8865 7.53676 14.6895 7.72431L14.6 7.8L11.667 10L14.6 12.2C14.8518 12.3889 15 12.6852 15 13V15C15 16.6569 13.6569 18 12 18H8C6.34315 18 5 16.6569 5 15V13C5 12.6852 5.14819 12.3889 5.4 12.2L8.333 10L5.4 7.8C5.17967 7.63475 5.03867 7.38717 5.00686 7.117L5 7V5C5 3.40232 6.24892 2.09634 7.82373 2.00509L8 2H12ZM10 11.25L7 13.5V15C7 15.5523 7.44772 16 8 16H12L12.1166 15.9933C12.614 15.9355 13 15.5128 13 15V13.5L10 11.25ZM8 4H12L12.1166 4.00673L12.2293 4.02641C12.6711 4.13005 13 4.52661 13 5V6H7V5L7.00673 4.88338C7.06449 4.38604 7.48716 4 8 4Z" />
            </svg>
            <span>
              {this.props.status === "preparing" && <span className="contest-task-timer-caption">Начнётся через</span>}
              {
                this.props.status === "ended" ? "Закончен" :
                <Timer
                  now={this.props.server_time}
                  expiryTimestamp={this.props.destination_time}
                  onExpire={() => this.props.onTimerExpire()}
                />
              }
            </span>
          </div>
        </div>
        <nav className="contest-sidebar-nav" ref={this.nav_ref}>
          {contest_data.length > 0 && <ContestSidebarSeparator />}
          {contest_data.map((element, index) => {
            const number = contest_data.length <= 26 ? CONTEST_LETTERS[index] : element.id;

            return this.renderItem({
              id: element.id,
              className: "task",
              label: `${number}. ${element.name}`,
              content: <span className="contest-sidebar-label">
                <span className="contest-sidebar-letter">{number}</span>
                <span className="contest-sidebar-name">. {element.name}</span>
              </span>,
            });
          })}
          <ContestSidebarSeparator />
          {sections.map(section => this.renderItem({
            id: section.id,
            unread: section.unread,
            content: <span className="contest-sidebar-label">{section.title}</span>,
          }))}
        </nav>
      </div>;
  }
}

function UpdateButton(props) {
  const [canUpdate, setCanUpdate] = useState(true);

  return <button type="button" aria-label="Обновить" className={clsx("rating-refresh-button", !canUpdate && "disabled")} onClick={() => {
    if (canUpdate) {
      props.onClick();
      setCanUpdate(false);
      setTimeout(() => setCanUpdate(true), 5000);
    }
  }}>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.53677 4.00628L9.25105 2.25628C9.58579 1.91457 10.1285 1.91457 10.4632 2.25628C10.7722 2.57171 10.796 3.06803 10.5345 3.41129L10.4632 3.49372L10.11 3.8546C12.8934 4.38607 15 6.8794 15 9.875C15 13.2577 12.3137 16 9 16C5.68629 16 3 13.2577 3 9.875C3 8.95566 3.19913 8.06343 3.57772 7.24978C3.78083 6.81327 4.29212 6.62749 4.71972 6.83483C5.14732 7.04217 5.32931 7.56411 5.1262 8.00062C4.85621 8.58088 4.71429 9.21678 4.71429 9.875C4.71429 12.2912 6.63307 14.25 9 14.25C11.3669 14.25 13.2857 12.2912 13.2857 9.875C13.2857 7.98655 12.1136 6.37755 10.4716 5.76473C10.7979 6.10784 10.795 6.65505 10.4632 6.99372C10.1542 7.30914 9.66805 7.33341 9.3318 7.06651L9.25105 6.99372L7.53677 5.24372C7.22778 4.92829 7.20401 4.43197 7.46546 4.08871L7.53677 4.00628L9.25105 2.25628L7.53677 4.00628Z" transition="fill var(--transition-timing) var(--transition-function)" />
    </svg>
    <span className="rating-refresh-text">Обновить</span>
  </button>;
}

function formatRatingTime(seconds) {
  return Math.floor(seconds / 60) + ":" + String(seconds % 60).padStart(2, "0");
}

/*
  A real table: one column per task. It scrolls inside its own wrapper when it doesn't fit, with the
  participant column pinned on the left and Σ on the right.
*/
function RatingTable(props) {
  const context = useContext(GlobalContext);

  const emptyRating = <div className="rating-error-container">
    <h2>Никто не сдал<br /> ни одного решения</h2>
    <p>Будьте первым!</p>
  </div>;

  if (props.rating[0] === "error") {
    return <div className="rating-error-container">
      <h2>Упс... Что-то пошло не так</h2>
      <p>На сайте возникла ошибка: <span style={ {fontSize: "16px", color: "var(--compilation-error)", transition: "color var(--transition-timing) var(--transition-function)",} }>{props.rating[1]}</span></p>
      <p>Можете разобраться с ней сами (вы же программист) или <a href="https://t.me/sort_me_chat" target="_blank" rel="noreferrer">обратиться к нам.</a></p>
    </div>;
  } else if (props.rating[0] === "empty") {
    return emptyRating;
  }

  // [{сумма баллов предыдущего участника, время предыдущего участника}, тип строки предыдущего участника]
  // true - обычная строка, false - secondary строка
  let previous = [{sum: null, time: null,}, true];

  // Column width depends on the number of tasks (see .rating-table.small/.middle/.big)
  const tasks_count = props.rating[0]?.results.length ?? 0;
  const class_type = tasks_count <= 8 ? "small" : (tasks_count <= 10 ? "middle" : "big");

  return <>
    {props.frozen && <div className="rating-frozen-header">
      <div className="rating-frozen-left">
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
          <path d="M10.5558 15.6435V4.99299L13.238 2.31022C13.238 2.31022 13.6308 1.91744 13.238 1.5241C12.8452 1.13133 12.4525 1.5241 12.4525 1.5241L10.5558 3.42133V0.873549C10.5558 0.873549 10.5558 0.317993 10.0002 0.317993C9.44468 0.317993 9.44468 0.873549 9.44468 0.873549V3.42133L7.54801 1.5241C7.54801 1.5241 7.15524 1.13133 6.76246 1.5241C6.36968 1.91744 6.76246 2.31022 6.76246 2.31022L9.44468 4.99299V15.6435L6.76246 18.3258C6.76246 18.3258 6.36968 18.7185 6.76246 19.1113C7.15524 19.5041 7.54801 19.1113 7.54801 19.1113L9.44468 17.2147V19.7624C9.44468 19.7624 9.44468 20.318 10.0002 20.318C10.5558 20.318 10.5558 19.7624 10.5558 19.7624V17.2147L12.4525 19.1113C12.4525 19.1113 12.8452 19.5041 13.238 19.1113C13.6308 18.7185 13.238 18.3258 13.238 18.3258L10.5558 15.6435Z" fill="#88C9F9"/>
          <path d="M19.2338 11.9102C19.0899 11.3736 18.5532 11.5175 18.5532 11.5175L14.8893 12.4991L5.66545 7.17358L4.68379 3.50969C4.68379 3.50969 4.5399 2.97303 4.00323 3.11692C3.46601 3.2608 3.61045 3.79747 3.61045 3.79747L4.3049 6.38858L2.09823 5.11414C2.09823 5.11414 1.61712 4.83636 1.33934 5.31747C1.06156 5.79858 1.54267 6.07636 1.54267 6.07636L3.74879 7.35025L1.15767 8.04414C1.15767 8.04414 0.620452 8.18803 0.764896 8.72469C0.908785 9.26192 1.44545 9.11803 1.44545 9.11803L5.1099 8.13636L14.3338 13.4619L15.3155 17.1264C15.3155 17.1264 15.4593 17.663 15.996 17.5191C16.5327 17.3747 16.3888 16.8386 16.3888 16.8386L15.6943 14.2475L17.901 15.5214C17.901 15.5214 18.3827 15.7991 18.6605 15.3186C18.9382 14.8369 18.4566 14.5591 18.4566 14.5591L16.2505 13.2852L18.841 12.5914C18.841 12.5908 19.3777 12.4469 19.2338 11.9102V11.9102Z" fill="#88C9F9"/>
          <path d="M18.8424 8.0441L16.2513 7.34965L18.458 6.07576C18.458 6.07576 18.9396 5.79743 18.6618 5.31632C18.3835 4.83465 17.9024 5.11298 17.9024 5.11298L15.6963 6.38632L16.3902 3.79576C16.3902 3.79576 16.5341 3.2591 15.9974 3.11521C15.4607 2.97132 15.3169 3.50798 15.3169 3.50798L14.3352 7.17187L5.11074 12.4991L1.4474 11.5169C1.4474 11.5169 0.910738 11.373 0.766849 11.9097C0.622405 12.4469 1.15963 12.5902 1.15963 12.5902L3.75018 13.2841L1.54407 14.558C1.54407 14.558 1.06352 14.8363 1.34129 15.3174C1.61907 15.798 2.09963 15.5202 2.09963 15.5202L4.30629 14.2463L3.61185 16.8369C3.61185 16.8369 3.46796 17.3741 4.00463 17.5174C4.54185 17.6619 4.68574 17.1252 4.68574 17.1252L5.66796 13.4602L14.8924 8.13521L18.5563 9.11743C18.5563 9.11743 19.093 9.26132 19.2368 8.72465C19.3785 8.18743 18.8424 8.0441 18.8424 8.0441V8.0441Z" fill="#88C9F9"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="20" height="20" fill="white" transform="translate(0 0.317993)"/>
          </clipPath>
        </defs>
      </svg>
        <span>Таблица заморожена</span>
      </div>
      <span><Timer expiryTimestamp={Date.now() + props.unfreeze_in * 1000} onExpire={() => props.onUnfreeze()} /></span>
    </div>}
    {props.rating.length > 0 ? <div className="rating-table-scroll">
      <table className={clsx("rating-table", class_type)}>
        <thead>
          <tr>
            <th className="rating-user-title" />
            {props.rating[0].results.map((element, index) => {
              return <th key={index} className="rating-cell">{tasks_count <= 26 ? CONTEST_LETTERS[index] : index + 1}</th>;
            })}
            <th className="rating-cell rating-sum" aria-label="Сумма">
              <svg width="10" height="14" viewBox="25 9 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M32.9999 10C33.5522 10 33.9999 10.4477 33.9999 11C33.9999 11.5128 33.6139 11.9355 33.1165 11.9933L32.9999 12H29.0799L31.7808 15.3753C32.0464 15.7073 32.0706 16.1664 31.8532 16.5215L31.7808 16.6247L29.0789 20H32.9999C33.5128 20 33.9354 20.386 33.9932 20.8834L33.9999 21C33.9999 21.5128 33.6139 21.9355 33.1165 21.9933L32.9999 22H26.9999C26.1995 22 25.7384 21.1162 26.1537 20.4664L26.2191 20.3753L29.7189 16L26.2191 11.6247C25.7191 10.9997 26.1211 10.0875 26.8879 10.0059L26.9999 10H32.9999Z" fill="var(--highlighted-text)" style={ {transition: "fill var(--transition-timing) var(--transition-function)",} } />
              </svg>
            </th>
          </tr>
        </thead>
        <tbody>
          {props.rating.map((element, index) => {
            return <tr
              key={index}
              className={element.uid === context.uid ? "primary" : (() => {
                if (!(previous[0].sum === null || (previous[0].sum === element.sum && previous[0].time === element.time))) {
                  previous[1] = !previous[1];
                }
                previous[0] = {sum: element.sum, time: element.time,};
                return previous[1] ? "" : "secondary";
              })()}
            >
              <td className="rating-user-title">
                <div className="rating-user">
                  <span className={clsx("rating-place", element.place > 9999 && "shift")}>{element.place}</span>
                  <UserAvatar src={element.avatar} size={24} />
                  <div className="rating-user-name">
                    <Link to={"/profile/" + element.uid} title={element.login}>{element.login}</Link>
                    {element.label > 0 && <span className="user-label">{props.labels[element.label]}</span>}
                  </div>
                </div>
              </td>
              {element.results.map((taskElement, index) => {
                const content = taskElement[0] === -1 ? <p>-</p> : <>
                  <p className={clsx(taskElement[0] === 100 ? "green" : (taskElement[0] === 0 ? "red" : null))}>{taskElement[0]}</p>
                  <span>{formatRatingTime(taskElement[1])}</span>
                </>;

                return <td key={index} className="rating-cell">
                  {props.isAdmin && taskElement[0] !== -1 ? <button
                    type="button"
                    className="rating-cell-button"
                    onClick={() => props.showSubmissionList(element.uid, props.contestTasksData[index].id, element.login, props.contestTasksData[index].name)}
                  >{content}</button> : content}
                </td>;
              })}
              <td className="rating-cell rating-sum">
                {element.sum === -1 ? <p>-</p> : <>
                  <p>{element.sum}</p>
                  <span>{formatRatingTime(element.time)}</span>
                </>}
              </td>
            </tr>;
          })}
        </tbody>
      </table>
    </div> : emptyRating}
  </>;
}

function RatingPages(props) {
  const context = useContext(GlobalContext);

  if (!props.pages) {
    return null;
  }

  // Long tables only get the first and last pages, the neighbourhood of the current one and the user's own page
  const shown = [];
  for (let i = 1; i <= props.pages; i++) {
    if (props.pages <= 27 || i === 1 || i === props.pages || Math.abs(i - props.current) <= 2 || i === props.my_page) {
      shown.push(i);
    }
  }

  return <nav className="rating-pages-container" aria-label="Страницы рейтинга">
    {shown.map((i, index) => <React.Fragment key={i}>
      {index > 0 && i - shown[index - 1] > 1 && <span className="rating-pages-gap">…</span>}
      <button
        type="button"
        disabled={props.current === i}
        aria-current={props.current === i ? "page" : undefined}
        className={clsx("rating-page-link", props.my_page === i && "rating-my-page", props.current === i && "selected")}
        onClick={() => props.setPage(i)}
      >{props.my_page === i && <UserAvatar user_id={context.uid} className="rating-page-avatar" size={12} />}<span>{i}</span></button>
    </React.Fragment>)}
  </nav>;
}

class ContestRating extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      table: [],
      frozen: null,
      unfreeze_in: null,
      me: null,
      pages: null,
      my_page: null,
      loading: true,
      current_page: 1,
      selectedLabel: 0,
      labels: [ "Все участники", ],
    };
  }

  componentDidMount() {
    this.getRating();
  }

  setPage(page) {
    this.setState({ loading: true, current_page: page, });

    this.getRating(page, this.state.selectedLabel);
  }

  setLabel(label) {
    this.setState({ loading: true, current_page: 1, selectedLabel: label, });
    this.getRating(1, label);
  }

  getRating(page = 1, label = 0) {
    const apiResponse = _fetchApi(`/getContestTable?contestid=${this.props.params.contest_id}&page=${page}&label=${label}`, this.context.token ? {
      method: "GET",
      headers: {"Authorization": "Bearer " + this.context.token,},
    } : {method: "GET",}).then(response => response.json());
    apiResponse.then(result => {
      if (result.hasOwnProperty("error")) {
        switch (result.error) {
          case "no such contest or table is empty":
            this.setState({ table: ["empty"], loading: false, });
            break;
          default:
            this.setState({ table: ["error", result.error], loading: false, });
            break;
        }
      } else {
        this.setState({
          table: result.table,
          labels: [ "Все участники", ...result.labels, ],
          frozen: result.frozen,
          unfreeze_in: result.unfreeze_in ?? null,
          me: result.you ?? null,
          pages: result.pages,
          my_page: result.your_page ?? null,
          loading: false,
        });
      }
    });
  }

  render() {
    return <div className="contest-rating">
      {(() => {
        if (this.props.archived) {
          return (
            <h2>Результаты</h2>
          )
        } else if (!this.state.frozen) {
          return (
            <>
              <h2>Текущий рейтинг</h2>
              <div className="contest-rating__header">
                <UpdateButton
                  onClick={() => {
                    this.setState({ loading: true, });
                    this.getRating(this.state.current_page, this.state.selectedLabel);
                  }}
                />
                {this.state.labels.length > 0 && <LabelFilter
                  labels={this.state.labels}
                  selectedLabel={this.state.selectedLabel}
                  setLabel={label => this.setLabel(label)}
                />}
              </div>
            </>
          )
        } else {
          return (
            <></>
          )
        }
      })()}
      {this.state.loading ? <Loader /> : <>
        <RatingTable
          rating={this.state.table}
          labels={this.state.labels}
          frozen={this.state.frozen}
          unfreeze_in={this.state.unfreeze_in}
          me={this.state.me}
          onUnfreeze={() => {
            this.setState({ loading: true, });
            this.getRating(this.state.current_page, this.state.selectedLabel);
          }}
          setLabel={label => this.setLabel(label)}
          isAdmin={this.props.isAdmin}
          showSubmissionList={this.props.showSubmissionList}
          contestTasksData={this.props.contestTasksData }
        />
        <RatingPages
          pages={this.state.pages}
          my_page={this.state.my_page}
          setPage={page => this.setPage(page)}
          current={this.state.current_page}
        />
      </>}
    </div>;
  }
}

function LabelButton({ selected, onClick, children }) {
  return (
    <button
      type="button"
      className={clsx("label-button", selected && "selected")}
      aria-pressed={selected}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

// Participant groups as a chip row; it scrolls horizontally when the chips don't fit
function LabelFilter({ labels, selectedLabel, setLabel }) {
  return (
    <div className="contest-rating__label-container">
      {labels.map((element, index) => <LabelButton
        key={index}
        selected={index === selectedLabel}
        onClick={() => setLabel(index)}
      >
        {element}
      </LabelButton>)}
    </div>
  )
}

class ContestJuryConnection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      announcements: [],
      messages: [],
    }

    this.jury_socket = null;
    this.sent_messages = [];
    this.message_queue = [];
    this.queue_working_state = false;
  }

  dequeue(append_to_sent = true) {
    if (this.message_queue.length > 0 && !this.queue_working_state) {
      const message_text = this.message_queue.shift();
      this.queue_working_state = true;
      this.sendNewMessage(message_text, append_to_sent);
      if (this.message_queue.length > 0) {
        setTimeout(() => {
          this.queue_working_state = false;
          this.dequeue(append_to_sent);
        }, 10000);
      } else {
        this.queue_working_state = false;
      }
    }
  }

  handleNewMessage(message) {
    if (message.is_broadcast) {
      this.setState({
        announcements: [{
          text: message.text,
          sent: Math.floor(Date.now() / 1000),
        }].concat(this.state.announcements),
      });
    } else {
      this.setState({
        messages: [{
          from_jury: true,
          text: message.text,
          sent: Math.floor(Date.now() / 1000),
        }].concat(this.state.messages),
      });
    }
  }

  sendNewMessage(text, append_to_sent = true) {
    if (this.jury_socket.readyState === WebSocket.OPEN) {
      const counts = readMessageCounts(this.props.params.contest_id);
      counts[this.props.params.contest_id].chat += 1;
      writeMessageCounts(counts);

      this.jury_socket.send(text);
      this.setState({
        messages: [{
          from_jury: false,
          text: text,
          sent: Math.floor(Date.now() / 1000),
        }].concat(this.state.messages),
      });
      if (append_to_sent) {
        this.sent_messages.push({
          from_jury: false,
          text: text,
          sent: Math.floor(Date.now() / 1000),
        });
      }
    }
  }

  initJuryChat(messages) {
    this.setState({messages: messages,});
    if (this.sent_messages.length !== messages.length && this.sent_messages.length !== 0) {
      for (let i = messages.length - 1; i < this.sent_messages.length; i++) {
        const message = this.sent_messages[i];
        if (!message.from_jury) {
          this.message_queue.push(message.text);
        }
      }
      this.dequeue(false);
    } else {
      this.sent_messages = messages;
    }
  }

  initAnnouncements(announcements) {
    this.setState({announcements: announcements,});
  }

  render() {
    if (this.props.type === "messages") {
      return <ContestJuryChat
        {...this.props}
        data={this.state.messages}
        socket={this.jury_socket}
        sendMessage={text => {
          this.message_queue.push(text);
          this.dequeue();
        }}
      />;
    } else  if (this.props.type === "announcements") {
      return <ContestJuryAnnouncements
        {...this.props}
        data={this.state.announcements}
      />;
    } else {
      return <></>;
    }
  }
}

class ContestJuryAnnouncements extends React.Component {
  render() {
    return <div className="contest-jury-connection">
      <h2>Объявления</h2>
      <p className="announcement-description">В этом разделе жюри делает важные уточнения для всех участников. Если тут появится что-то новенькое, вам придёт оповещение.</p>
      <div className="announcement-list">
        {this.props.data.map((element, index) => {
          // new announcements are prepended: count keys from the oldest one so they stay stable
          return <div className="announcement-container" key={this.props.data.length - index}>
            <img src={announcement_icon} alt="" />
            <div>
              <Markdown>{element.text}</Markdown>
              <span className="announcement-timestamp">{juryConnectionDateConverter(element.sent)}</span>
            </div>
          </div>;
        })}
      </div>
    </div>;
  }
}

/*
  A column that fits the screen: title, tips, then the message list (its own scroller) with the composer
  under it. The list is column-reverse, so it starts at the bottom and new messages (prepended to the
  data) appear there without any scrolling code.
*/
class ContestJuryChat extends React.Component {
  constructor(props) {
    super(props);

    // Tips are a side column on desktop and a collapsed <details> above the chat on smaller screens.
    // Decided once: React never touches the attribute again, so the user's own toggling wins.
    this.tips_open = window.matchMedia ? window.matchMedia("(min-width: 1100px)").matches : true;
  }

  render() {
    if (this.props.messaging_enabled) {
      if (this.props.status === "ended") {
        return <div className="contest-jury-connection">
          <h2>Чат с Жюри</h2>
          <p>Соревнование окончено. Чат с жюри больше не доступен.</p>
        </div>;
      } else if (this.props.socket?.readyState === WebSocket.OPEN) {
        return <div className="contest-jury-connection contest-jury-chat">
            <h2>Чат с Жюри</h2>
            <details className="jury-chat-tip-container" open={this.tips_open}>
              <summary>Когда и как писать жюри</summary>
              <div className="jury-chat-tip">
                <h3>Когда стоит писать жюри</h3>
                <ul>
                  <li><p>Условие задачи кажется вам противоречивым</p></li>
                  <li><p>Примеры к задаче не соответствуют условию</p></li>
                  <li><p>У вас неполадки с тестирующей системой</p></li>
                </ul>
                <p>Если вы пишете олимпиаду под прокторингом, скорее всего, вам нужно писать жюри, чтобы отпроситься в туалет или уйти пораньше.</p>
              </div>
              <div className="jury-chat-tip">
                <h3>Как общаться с жюри</h3>
                <ul>
                  <li><p>Кратко опишите суть проблемы</p></li>
                  <li><p>Наберитесь терпения: обычно жюри загружено</p></li>
                  <li><p>Будьте вежливы</p></li>
                </ul>
                <p>В чате указано московское время.</p>
              </div>
            </details>
            <div className="jury-chat-main">
              <div className="jury-chat-messages">
                {this.props.data.length > 0 ? this.props.data.map((element, index) => {
                  // messages are prepended: count keys from the oldest one so they stay stable
                  return <ChatMessage
                    key={this.props.data.length - index}
                    text={element.text}
                    sent={element.sent}
                    from_jury={element.from_jury}
                  />;
                }) : <div className="jury-chat-no-messages">
                  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M6.272 1.95258C5.174 1.95258 4.077 2.34958 3.241 3.14458C2.441 3.90658 2 4.91758 2 5.99158C2 7.06458 2.441 8.07558 3.241 8.83758L10 15.2696L16.759 8.83758C17.559 8.07558 18 7.06458 18 5.99158C18 4.91858 17.559 3.90658 16.759 3.14458C15.088 1.55458 12.368 1.55458 10.697 3.14458L10 3.80858L9.303 3.14458C8.467 2.34958 7.37 1.95258 6.272 1.95258ZM10 17.9996L1.847 10.2406C0.656 9.10758 0 7.59858 0 5.99158C0 4.38458 0.656 2.87558 1.847 1.74158C4.067 -0.371417 7.552 -0.561417 10 1.16858C12.448 -0.561417 15.933 -0.371417 18.153 1.74158C19.344 2.87558 20 4.38458 20 5.99158C20 7.59858 19.344 9.10758 18.153 10.2406L10 17.9996Z" fill="var(--difficulty)"/>
                  </svg>
                  <p><strong>Жюри - это как девушка</strong><br /> Вы должны написать первым</p>
                </div>}
              </div>
              <div className="jury-chat-input-container">
                <ChatBox
                  textarea_id="jury-chat-input"
                  sendMessage={text => this.props.sendMessage(text)}
                />
              </div>
            </div>
          </div>;
      } else {
        return <div className="contest-jury-connection">
          <h2>Чат с Жюри</h2>
          <WebSocketLoader text="Подключение..." />
        </div>;
      }
    } else {
      return <div className="contest-jury-connection">
        <h2>Чат с жюри отключен для этого соревнования.</h2>
      </div>;
    }
  }
}

function ChatMessage(props) {
  const context = useContext(GlobalContext);

  const text = props.text.replaceAll(":thinking:", "🤔").replaceAll(":sweating:", "😰").replaceAll(":sh*t:", "🤬").replaceAll(":clown:", "🤡").replaceAll(":praying:", "🙏").replaceAll(":coffin:", "⚰️").replaceAll(":sortme:", "🤣").replaceAll(":mstore:", "🤪");

  return <div className="chat-message">
    {props.from_jury ? <img className="chat-message-avatar" alt="" src={jury_avatar} width="36" height="36" /> : <UserAvatar user_id={context.uid} size={36} />}
    <div className="chat-message-content">
      <div className="chat-message-header">
        <p>{props.from_jury ? <span className="chat-message-jury">Жюри</span> : <span>{context.login}</span>} {juryConnectionDateConverter(props.sent)}</p>
      </div>
      <p>{emoji(text)}</p>
    </div>
  </div>;
}

function AdminPage({ params, onTimerExpire, contestTasksData, updateContestData }) {
  const context = useContext(GlobalContext);

  const [data, setData] = useState(null);

  useEffect(() => {
    _fetchApi(`/getContestData?id=${params.contest_id}`, context.token ? {
      method: "GET",
      headers: { "Authorization": "Bearer " + context.token, },
    } : { method: "GET", }).then(response => response.json()).then(result => setData(result));
  }, []);

  if (data === null) {  // loading
    return <div className="admin-container">
      <h2>Параметры контеста</h2>
      <Loader />
    </div>;
  } else if (data.hasOwnProperty("error")) { // error
    return <div className="admin-container">
      <h2 className="admin-denied-title">Параметры контеста</h2>
      <p>У вас нет доступа к этому разделу.</p>
    </div>;
  } else { // content
    return <div className="admin-container">
      <h2>Параметры контеста</h2>
      <div className="admin-flex">
        <AdminInfo contestData={data} contestId={params.contest_id} refreshPage={onTimerExpire} />
        <AdminTasks contestData={contestTasksData} contestId={params.contest_id} updateContestData={updateContestData} />
      </div>
    </div>;
  }
  
}

function AdminInfo({ contestData, contestId, refreshPage }) {
  return <div className="admin-info">
    <AdminInfoForm contestData={contestData} contestId={contestId} refreshPage={refreshPage} />
    <AdminLink contestData={contestData} contestId={contestId} />
    <AdminListWrapper contestData={contestData} contestId={contestId} />
  </div>;
}

function AdminInfoForm({ contestData, contestId, refreshPage }) {
  const context = useContext(GlobalContext);
  
  const [hasLengthError, setLengthError] = useState(false);
  const [hasRegistrationError, setRegistrationError] = useState(false);

  return <div className="admin-info-form">
    <LabeledInput
      id="contest-title-input"
      title="Название"
      mainClassName="admin-info-input"
      defaultValue={contestData.name}
    />
    <TextLabeledInput
      id="contest-description-input"
      title="Описание (Markdown)"
      mainClassName="admin-info-input"
      defaultValue={contestData.description }
    />
    <AdminDatetimeEdit
      idBegin="contest-begin"
      idEnd="contest-end"
      titleBegin="Начало"
      titleEnd="Конец"
      begins={new Date(contestData.starts * 1000 + (3 * 60 * 60 * 1000)).toISOString().slice(0, 16)}
      ends={new Date(contestData.ends * 1000 + (3 * 60 * 60 * 1000)).toISOString().slice(0, 16)}
      hasError={hasLengthError}
      onChange={() => setLengthError(false)}
    />
    <AdminDatetimeEdit
      idBegin="contest-registration-begin"
      idEnd="contest-registration-end"
      titleBegin="Начало регистрации"
      titleEnd="Конец регистрации"
      begins={new Date(contestData.register_starts * 1000 + (3 * 60 * 60 * 1000)).toISOString().slice(0, 16)}
      ends={new Date(contestData.register_ends * 1000 + (3 * 60 * 60 * 1000)).toISOString().slice(0, 16)}
      hasError={hasRegistrationError}
      onChange={() => setRegistrationError(false)}
    />
    <MainButton
      className="contest-save-changes"
      onClick={async () => {
        const beginTimeRaw = new Date(document.getElementById("contest-begin").value);
        const endTimeRaw = new Date(document.getElementById("contest-end").value);
        const registrationBeginTimeRaw = new Date(document.getElementById("contest-registration-begin").value);
        const registrationEndTimeRaw = new Date(document.getElementById("contest-registration-end").value);

        let error = false;
        const beginTime = (beginTimeRaw.getTime() - beginTimeRaw.getTimezoneOffset() * 60 * 1000 - 3 * 60 * 60 * 1000) / 1000;
        const endTime = (endTimeRaw.getTime() - endTimeRaw.getTimezoneOffset() * 60 * 1000 - 3 * 60 * 60 * 1000) / 1000;
        if (beginTime >= endTime) {
          setLengthError(true);
          error = true;
        }

        const registrationBeginTime = (registrationBeginTimeRaw.getTime() - registrationBeginTimeRaw.getTimezoneOffset() * 60 * 1000 - 3 * 60 * 60 * 1000) / 1000;
        const registrationEndTime = (registrationEndTimeRaw.getTime() - registrationEndTimeRaw.getTimezoneOffset() * 60 * 1000 - 3 * 60 * 60 * 1000) / 1000;
        if (registrationBeginTime >= registrationEndTime) {
          setRegistrationError(true);
          error = true;
        }

        if (error) {
          return;
        }
        
        const apiResponse = await _fetchApi("/setContestInfo", {
          method: "POST",
          headers: { "Authorization": "Bearer " + context.token,
                    "Content-Type": "application/json", },
          body: JSON.stringify({
            "id": parseInt(contestId),
            "info": {
              "name": document.getElementById("contest-title-input").value,
              "description": document.getElementById("contest-description-input").value,
              "starts": beginTime > 0 ? beginTime : 1,
              "ends": endTime > 0 ? endTime : 1,
              "register_starts": registrationBeginTime > 0 ? registrationBeginTime : 1,
              "register_ends": registrationEndTime > 0 ? registrationEndTime : 1,
            } 
          }),
        }).then(response => response.json());
        if (!apiResponse.hasOwnProperty("error")) {
          refreshPage();
        }
        return apiResponse;
      }}
    >
      Сохранить настройки
    </MainButton>
  </div>;
}

function AdminLink({ contestData, contestId }) {
  const context = useContext(GlobalContext);

  const [link, setLink] = useState(contestData.access_link);

  return <div className="admin-link">
    <p>Ссылка на контест</p>
    <div className="admin-link-flex">
      <a rel="noreferrer" target="_blank" href={"https://" + link}>
        {link}
      </a>
      <SecondaryButton
        onClick={async () => {
          const apiResponse = await _fetchApi(`/resetAccessLink?contest_id=${contestId}`, context.token ? {
            method: "POST",
            headers: { "Authorization": "Bearer " + context.token, },
          } : { method: "POST", }).then(response => response.json());
          if (!apiResponse.hasOwnProperty("error")) {
            setLink(apiResponse.access_link);
          }
        }}
      >
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M3.73735 8.99644C4.12193 8.98996 4.44377 9.2741 4.49338 9.64632L4.4999 9.73369L4.50262 9.9015C4.58434 12.3205 6.57243 14.2463 9 14.2463C9.14022 14.2463 9.27951 14.2399 9.41756 14.2273L9.21967 14.0267C8.92678 13.7338 8.92678 13.2589 9.21967 12.966C9.51257 12.6731 9.98744 12.6731 10.2803 12.966L11.7803 14.466C12.0732 14.7589 12.0732 15.2338 11.7803 15.5267L10.2803 17.0267C9.98744 17.3196 9.51257 17.3196 9.21967 17.0267C8.92678 16.7338 8.92678 16.2589 9.21967 15.966L9.45836 15.7291C9.30646 15.7405 9.15359 15.7463 9 15.7463C5.82653 15.7463 3.21665 13.2784 3.0125 10.1292L3.00315 9.93947L3.00011 9.75899C2.99312 9.34483 3.3232 9.00343 3.73735 8.99644ZM8.78033 2.46601C9.0507 2.73637 9.07149 3.16179 8.84272 3.45601L8.78033 3.52667L8.54187 3.7636C8.69371 3.75212 8.8465 3.74634 9 3.74634C12.3137 3.74634 15 6.43263 15 9.74634C15 10.1606 14.6642 10.4963 14.25 10.4963C13.8358 10.4963 13.5 10.1606 13.5 9.74634C13.5 7.26106 11.4853 5.24634 9 5.24634C8.8597 5.24634 8.72034 5.25274 8.58221 5.26542L8.78033 5.46601C9.07323 5.7589 9.07323 6.23377 8.78033 6.52667C8.50997 6.79703 8.08455 6.81783 7.79033 6.58906L7.71967 6.52667L6.21967 5.02667C5.94931 4.7563 5.92851 4.33088 6.15728 4.03666L6.21967 3.96601L7.71967 2.46601C8.01257 2.17311 8.48744 2.17311 8.78033 2.46601Z" fill="var(--button-color)" transition="fill var(--transition-timing) var(--transition-function)" />
        </svg>
        Новая
      </SecondaryButton>
    </div>
  </div>;
}

function AdminListWrapper({ contestData, contestId }) {
  const context = useContext(GlobalContext);

  const [admins, setAdmins] = useState(contestData.admins);
  const [error, setError] = useState(null);

  const deleteAdmin = async id => {
    const apiResponse = await _fetchApi(`/removeAdminFromContest?contest_id=${contestId}&user_id=${id}`, context.token ? {
      method: "POST",
      headers: { "Authorization": "Bearer " + context.token, },
    } : { method: "POST", }).then(response => response.json());
    if (apiResponse.hasOwnProperty("error")) {
      setError("Пользователь не найден");
    } else {
      setAdmins(apiResponse.admins);
    }
  };

  const addAdmin = async () => {
    const apiResponse = await _fetchApi(`/addAdminToContest?contest_id=${contestId}&user_handle=${document.getElementById("admin-list-add-input").value}`, context.token ? {
      method: "POST",
      headers: { "Authorization": "Bearer " + context.token, },
    } : { method: "POST", }).then(response => response.json());
    if (apiResponse.hasOwnProperty("error")) {
      setError("Пользователь не найден");
    } else {
      setAdmins(apiResponse.admins);
      document.getElementById("admin-list-add-input").value = "";
    }
  }

  return (
    <AdminList
      admins={admins}
      addFunc={addAdmin}
      deleteFunc={deleteAdmin}
      error={error}
      setError={setError}
      className="contest-edit__admin-list"
    />
  )
}

function AdminDatetimeEdit({ idBegin, idEnd, titleBegin, titleEnd, begins, ends, hasError, onChange }) {
  return <div className="admin-datetime-container">
    <DatetimeLabeledInput
      id={idBegin}
      title={titleBegin}
      mainClassName="admin-info-input"
      placeholder="ДД.ММ.ГГГГ ЧЧ:ММ"
      defaultValue={begins}
    />
    <DatetimeLabeledInput
      id={idEnd}
      title={titleEnd}
      mainClassName="admin-info-input admin-datetime-end"
      placeholder="ДД.ММ.ГГГГ ЧЧ:ММ"
      defaultValue={ends}
      errorText={hasError && "Не может быть раньше начала"}
      onChange={onChange}
    />
  </div>;
}

function AdminTasks({ contestData, contestId, updateContestData }) {
  const context = useContext(GlobalContext);

  const renderDraggable = useDraggableInPortal();

  const [error, setError] = useState(null);
  const [tasks, setTasks] = useState(contestData);

  const onDragEnd = result => {
    if (!result.destination) {
      return;
    }
    const newTasks = reorder(
      tasks,
      result.source.index,
      result.destination.index
    );

    setTasks(newTasks);
  }

  function handleTaskChange(newTasks) {
    updateContestData(newTasks);
    return _fetchApi("/setContestTasks", {
      method: "POST",
      headers: { "Authorization": "Bearer " + context.token,
                  "Content-Type": "application/json", },
      body: JSON.stringify({
        "contest_id": parseInt(contestId), 
        "tasks": newTasks.map(element => element.id),
      }),
    }).then(response => response.json());
  }

  function deleteTask(id) {
    setTasks(tasks.filter(element => element.id !== id))
  }
  
  return <div className="admin-tasks-container">
    <p className="admin-tasks-title">Задачи</p>
    {tasks.length > 0 && <div className="admin-tasks">
      {/* Slot letters stay in place while cards move; rows line up with the cards through CSS (same height + gap) */}
      <div className="tasks-numeration-sidebar" aria-hidden="true">
        {tasks.map((_, index) => <span key={index}>{tasks.length > 26 ? index + 1 : CONTEST_LETTERS[index]}</span>)}
      </div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, _snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef} className="task-list-droppable">
              {tasks.map((element, index) => (
                <Draggable key={element.id} draggableId={"task-draggable" + element.id} index={index}>
                  {renderDraggable((innerProvided, snapshot) => (
                    <div
                      ref={innerProvided.innerRef}
                      {...innerProvided.draggableProps}
                      {...innerProvided.dragHandleProps}
                    >
                      <TaskCard {...element} deleteTask={deleteTask} />
                    </div>
                  ))}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>}
    <div className="task-list-add-flex">
      <UnlabeledInput
        type="number"
        id="task-list-add-input"
        placeholder="ID задачи"
        maxLength={256}
        hasError={Boolean(error)}
        onChange={() => setError(null)}
      />
      <SecondaryButton
        className="tasks-add-button"
        onClick={async () => {

          if (tasks.map(element => element.id).includes(parseInt(document.getElementById("task-list-add-input").value))) {
            setError("Задача уже добавлена");
            return;
          } else if (tasks.length === 12) {
            setError("Превышен лимит задач");
            return;
          }

          const apiResponse = await _fetchApi(`/getTaskById?id=${document.getElementById("task-list-add-input").value}`, context.token ? {
            method: "GET",
            headers: { "Authorization": "Bearer " + context.token, },
          } : { method: "GET", }).then(response => response.json());
          if (apiResponse.hasOwnProperty("error")) {
            setError("Задача не найдена. Возможно, она не в публичном доступе, либо у вас нет прав на её редактирование.");
            return;
          }
          setTasks([...tasks, apiResponse.task]);
          document.getElementById("task-list-add-input").value = "";
        }}
      >
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M6.5714 6.04591L10.8489 6.04594C11.1649 6.04594 11.4202 5.79057 11.4202 5.47459C11.4202 5.15861 11.1648 4.90323 10.8489 4.90323L6.57139 4.9032L6.57136 0.625727C6.57136 0.309745 6.31598 0.0543715 6 0.0543694C5.68402 0.0543672 5.42865 0.309737 5.42865 0.625719L5.42868 4.90319L1.1512 4.90317C0.835222 4.90316 0.579853 5.15853 0.579855 5.47452C0.579856 5.6321 0.6437 5.77514 0.747142 5.87859C0.850584 5.98203 0.993625 6.04587 1.15121 6.04587L5.42869 6.0459L5.42872 10.3234C5.42872 10.481 5.49256 10.624 5.596 10.7274C5.69945 10.8309 5.84249 10.8947 6.00007 10.8947C6.31606 10.8947 6.57143 10.6394 6.57142 10.3234L6.5714 6.04591Z" fill="var(--additional-button-text)" transition="fill var(--transition-timing) var(--transition-function)" />
        </svg>
      </SecondaryButton>
      <MainButton
        className="tasks-save-button"
        onClick={() => {
          return handleTaskChange(tasks);
        }}
      >Сохранить задачи</MainButton>
    </div>
    {error && <span className="task-list-add-error">{error}</span>}
  </div>;
}

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

function TaskCard({ id, name, deleteTask }) {
  return <div className="task-draggable-card">
    <svg className="task-draggable-grip" width="5" height="14" viewBox="0 0 5 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="1" cy="1" r="1" fill="#D9D9D9"/>
      <circle cx="4" cy="4" r="1" fill="#D9D9D9"/>
      <circle cx="1" cy="7" r="1" fill="#D9D9D9"/>
      <circle cx="4" cy="10" r="1" fill="#D9D9D9"/>
      <circle cx="1" cy="13" r="1" fill="#D9D9D9"/>
    </svg>

    <span title={name}>{name}</span>
    <a href={`https://sort-me.org/tasks/${id}`} target="_blank" rel="noreferrer" title="Открыть задачу">
      ID: {id}
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.91797 1.16675H4.08464C4.4068 1.16675 4.66797 1.42792 4.66797 1.75008C4.66797 2.04924 4.44278 2.29579 4.15266 2.32949L4.08464 2.33341H2.91797C2.61881 2.33341 2.37226 2.5586 2.33856 2.84872L2.33464 2.91675V11.0834C2.33464 11.3826 2.55983 11.6291 2.84994 11.6628L2.91797 11.6667H11.0846C11.3838 11.6667 11.6303 11.4416 11.664 11.1514L11.668 11.0834V9.91675C11.668 9.59458 11.9291 9.33341 12.2513 9.33341C12.5505 9.33341 12.797 9.5586 12.8307 9.84872L12.8346 9.91675V11.0834C12.8346 12.0154 12.1061 12.7772 11.1875 12.8304L11.0846 12.8334H2.91797C1.98599 12.8334 1.22417 12.1049 1.17094 11.1862L1.16797 11.0834V2.91675C1.16797 1.98477 1.89651 1.22295 2.81514 1.16972L2.91797 1.16675H4.08464H2.91797ZM12.2513 1.16675L12.2986 1.1685L12.3684 1.17855L12.4334 1.19576L12.4982 1.22139L12.555 1.25191L12.6111 1.29087L12.6638 1.3376L12.7201 1.40282L12.7619 1.46771L12.78 1.50327L12.7997 1.55079L12.8137 1.59492L12.8306 1.68119L12.8346 1.75008V5.25008C12.8346 5.57225 12.5735 5.83342 12.2513 5.83342C11.9291 5.83342 11.668 5.57225 11.668 5.25008V3.15825L7.99711 6.82923C7.78683 7.03951 7.45595 7.05569 7.22711 6.87775L7.17216 6.82923C6.96187 6.61895 6.9457 6.28806 7.12363 6.05922L7.17216 6.00427L10.842 2.33341H8.7513C8.42914 2.33341 8.16797 2.07225 8.16797 1.75008C8.16797 1.42792 8.42914 1.16675 8.7513 1.16675H12.2513Z" fill="var(--button-color)" transition="fill var(--transition-timing) var(--transition-function)" />
      </svg>
    </a>
    <button type="button" aria-label="Убрать задачу" onClick={() => deleteTask(id)}>
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.01026 5.00021L9.79103 1.21947C10.0703 0.940185 10.0703 0.488753 9.79103 0.209466C9.51174 -0.0698219 9.06031 -0.0698219 8.78102 0.209466L5.00025 3.99021L1.21948 0.209466C0.940192 -0.0698219 0.488757 -0.0698219 0.209467 0.209466C-0.0698224 0.488753 -0.0698224 0.940185 0.209467 1.21947L3.99024 5.00021L0.209467 8.78096C-0.0698224 9.06024 -0.0698224 9.51167 0.209467 9.79096C0.348755 9.93025 0.531615 10.0002 0.714474 10.0002C0.897334 10.0002 1.08019 9.93025 1.21948 9.79096L5.00025 6.01022L8.78102 9.79096C8.92031 9.93025 9.10317 10.0002 9.28603 10.0002C9.46889 10.0002 9.65174 9.93025 9.79103 9.79096C10.0703 9.51167 10.0703 9.06024 9.79103 8.78096L6.01026 5.00021Z" fill="#C15555" />
      </svg>
    </button>
  </div>;
}

const ContestTaskWrapper = props => {
  const [key, setKey] = useState(0);

  function refreshPage() {
    setKey(key + 1);
  }

  return <ContestTask {...props} refreshPage={() => refreshPage()} params={useParams()} key={key} />;
}

export { TaskWrapper, ContestTaskWrapper };
